var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgAuth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 800,
    viewBox: "0 0 1280 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 -62H-117.895V-18H-160V-62ZM-158.997 -61H-118.897V-41H-158.997V-61ZM-160 -39H-139.95V-19H-160V-39ZM-137.945 -39H-117.895V-19H-137.945V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 -62H-75.7895V-18H-117.895V-62ZM-116.892 -61H-76.792V-41H-116.892V-61ZM-117.895 -39H-97.8446V-19H-117.895V-39ZM-95.8396 -39H-75.7895V-19H-95.8396V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 -62H218.947V-18H176.842V-62ZM177.845 -61H217.945V-41H177.845V-61ZM176.842 -39H196.892V-19H176.842V-39ZM198.897 -39H218.947V-19H198.897V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 -62H261.053V-18H218.947V-62ZM219.95 -61H260.05V-41H219.95V-61ZM218.947 -39H238.997V-19H218.947V-39ZM241.003 -39H261.053V-19H241.003V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 -62H555.789V-18H513.684V-62ZM514.687 -61H554.787V-41H514.687V-61ZM513.684 -39H533.734V-19H513.684V-39ZM535.739 -39H555.789V-19H535.739V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 -62H597.895V-18H555.789V-62ZM556.792 -61H596.892V-41H556.792V-61ZM555.789 -39H575.84V-19H555.789V-39ZM577.845 -39H597.895V-19H577.845V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 -62H976.842V-18H934.737V-62ZM935.739 -61H975.84V-41H935.739V-61ZM934.737 -39H954.787V-19H934.737V-39ZM956.792 -39H976.842V-19H956.792V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 -62H1018.95V-18H976.842V-62ZM977.845 -61H1017.94V-41H977.845V-61ZM976.842 -39H996.892V-19H976.842V-39ZM998.897 -39H1018.95V-19H998.897V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 -62H50.5263V-18H8.42105V-62ZM9.42355 -61H49.5238V-41H9.42355V-61ZM8.42105 -39H28.4712V-19H8.42105V-39ZM30.4762 -39H50.5263V-19H30.4762V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 -62H92.6316V-18H50.5263V-62ZM51.5288 -61H91.6291V-41H51.5288V-61ZM50.5263 -39H70.5764V-19H50.5263V-39ZM72.5815 -39H92.6316V-19H72.5815V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 -62H387.368V-18H345.263V-62ZM346.266 -61H386.366V-41H346.266V-61ZM345.263 -39H365.313V-19H345.263V-39ZM367.318 -39H387.368V-19H367.318V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 -62H429.474V-18H387.368V-62ZM388.371 -61H428.471V-41H388.371V-61ZM387.368 -39H407.419V-19H387.368V-39ZM409.424 -39H429.474V-19H409.424V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 -62H724.211V-18H682.105V-62ZM683.108 -61H723.208V-41H683.108V-61ZM682.105 -39H702.155V-19H682.105V-39ZM704.16 -39H724.211V-19H704.16V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 -62H766.316V-18H724.211V-62ZM725.213 -61H765.313V-41H725.213V-61ZM724.211 -39H744.261V-19H724.211V-39ZM746.266 -39H766.316V-19H746.266V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 -62H1145.26V-18H1103.16V-62ZM1104.16 -61H1144.26V-41H1104.16V-61ZM1103.16 -39H1123.21V-19H1103.16V-39ZM1125.21 -39H1145.26V-19H1125.21V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 -62H1187.37V-18H1145.26V-62ZM1146.27 -61H1186.37V-41H1146.27V-61ZM1145.26 -39H1165.31V-19H1145.26V-39ZM1167.32 -39H1187.37V-19H1167.32V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 -62H1313.68V-18H1271.58V-62ZM1272.58 -61H1312.68V-41H1272.58V-61ZM1271.58 -39H1291.63V-19H1271.58V-39ZM1293.63 -39H1313.68V-19H1293.63V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 -62H1355.79V-18H1313.68V-62ZM1314.69 -61H1354.79V-41H1314.69V-61ZM1313.68 -39H1333.73V-19H1313.68V-39ZM1335.74 -39H1355.79V-19H1335.74V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 -62H-33.6842V-18H-75.7895V-62ZM-74.787 -61H-34.6867V-41H-74.787V-61ZM-75.7895 -39H-55.7393V-19H-75.7895V-39ZM-53.7343 -39H-33.6842V-19H-53.7343V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 -62H8.42105V-18H-33.6842V-62ZM-32.6817 -61H7.41855V-41H-32.6817V-61ZM-33.6842 -39H-13.6341V-19H-33.6842V-39ZM-11.6291 -39H8.42105V-19H-11.6291V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 -62H303.158V-18H261.053V-62ZM262.055 -61H302.155V-41H262.055V-61ZM261.053 -39H281.103V-19H261.053V-39ZM283.108 -39H303.158V-19H283.108V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 -62H345.263V-18H303.158V-62ZM304.16 -61H344.261V-41H304.16V-61ZM303.158 -39H323.208V-19H303.158V-39ZM325.213 -39H345.263V-19H325.213V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 -62H640V-18H597.895V-62ZM598.897 -61H638.997V-41H598.897V-61ZM597.895 -39H617.945V-19H597.895V-39ZM619.95 -39H640V-19H619.95V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 -62H682.105V-18H640V-62ZM641.003 -61H681.103V-41H641.003V-61ZM640 -39H660.05V-19H640V-39ZM662.055 -39H682.105V-19H662.055V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 -62H1061.05V-18H1018.95V-62ZM1019.95 -61H1060.05V-41H1019.95V-61ZM1018.95 -39H1039V-19H1018.95V-39ZM1041 -39H1061.05V-19H1041V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 -62H1103.16V-18H1061.05V-62ZM1062.06 -61H1102.16V-41H1062.06V-61ZM1061.05 -39H1081.1V-19H1061.05V-39ZM1083.11 -39H1103.16V-19H1083.11V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 -62H134.737V-18H92.6316V-62ZM93.6341 -61H133.734V-41H93.6341V-61ZM92.6316 -39H112.682V-19H92.6316V-39ZM114.687 -39H134.737V-19H114.687V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 -62H176.842V-18H134.737V-62ZM135.739 -61H175.84V-41H135.739V-61ZM134.737 -39H154.787V-19H134.737V-39ZM156.792 -39H176.842V-19H156.792V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 -62H471.579V-18H429.474V-62ZM430.476 -61H470.576V-41H430.476V-61ZM429.474 -39H449.524V-19H429.474V-39ZM451.529 -39H471.579V-19H451.529V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 -62H513.684V-18H471.579V-62ZM472.581 -61H512.682V-41H472.581V-61ZM471.579 -39H491.629V-19H471.579V-39ZM493.634 -39H513.684V-19H493.634V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 -62H892.632V-18H850.526V-62ZM851.529 -61H891.629V-41H851.529V-61ZM850.526 -39H870.576V-19H850.526V-39ZM872.581 -39H892.632V-19H872.581V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 -62H934.737V-18H892.632V-62ZM893.634 -61H933.734V-41H893.634V-61ZM892.632 -39H912.682V-19H892.632V-39ZM914.687 -39H934.737V-19H914.687V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 -62H808.421V-18H766.316V-62ZM767.318 -61H807.419V-41H767.318V-61ZM766.316 -39H786.366V-19H766.316V-39ZM788.371 -39H808.421V-19H788.371V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 -62H850.526V-18H808.421V-62ZM809.424 -61H849.524V-41H809.424V-61ZM808.421 -39H828.471V-19H808.421V-39ZM830.476 -39H850.526V-19H830.476V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 -62H1229.47V-18H1187.37V-62ZM1188.37 -61H1228.47V-41H1188.37V-61ZM1187.37 -39H1207.42V-19H1187.37V-39ZM1209.42 -39H1229.47V-19H1209.42V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 -62H1271.58V-18H1229.47V-62ZM1230.48 -61H1270.58V-41H1230.48V-61ZM1229.47 -39H1249.52V-19H1229.47V-39ZM1251.53 -39H1271.58V-19H1251.53V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 -62H1397.89V-18H1355.79V-62ZM1356.79 -61H1396.89V-41H1356.79V-61ZM1355.79 -39H1375.84V-19H1355.79V-39ZM1377.84 -39H1397.89V-19H1377.84V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 -62H1440V-18H1397.89V-62ZM1398.9 -61H1439V-41H1398.9V-61ZM1397.89 -39H1417.94V-19H1397.89V-39ZM1419.95 -39H1440V-19H1419.95V-39Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 -18H-117.895V26H-160V-18ZM-158.997 -17H-118.897V3H-158.997V-17ZM-160 5H-139.95V25H-160V5ZM-137.945 5H-117.895V25H-137.945V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 -18H-75.7895V26H-117.895V-18ZM-116.892 -17H-76.792V3H-116.892V-17ZM-117.895 5H-97.8446V25H-117.895V5ZM-95.8396 5H-75.7895V25H-95.8396V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 -18H218.947V26H176.842V-18ZM177.845 -17H217.945V3H177.845V-17ZM176.842 5H196.892V25H176.842V5ZM198.897 5H218.947V25H198.897V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 -18H261.053V26H218.947V-18ZM219.95 -17H260.05V3H219.95V-17ZM218.947 5H238.997V25H218.947V5ZM241.003 5H261.053V25H241.003V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 -18H555.789V26H513.684V-18ZM514.687 -17H554.787V3H514.687V-17ZM513.684 5H533.734V25H513.684V5ZM535.739 5H555.789V25H535.739V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 -18H597.895V26H555.789V-18ZM556.792 -17H596.892V3H556.792V-17ZM555.789 5H575.84V25H555.789V5ZM577.845 5H597.895V25H577.845V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 -18H976.842V26H934.737V-18ZM935.739 -17H975.84V3H935.739V-17ZM934.737 5H954.787V25H934.737V5ZM956.792 5H976.842V25H956.792V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 -18H1018.95V26H976.842V-18ZM977.845 -17H1017.94V3H977.845V-17ZM976.842 5H996.892V25H976.842V5ZM998.897 5H1018.95V25H998.897V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 -18H50.5263V26H8.42105V-18ZM9.42355 -17H49.5238V3H9.42355V-17ZM8.42105 5H28.4712V25H8.42105V5ZM30.4762 5H50.5263V25H30.4762V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 -18H92.6316V26H50.5263V-18ZM51.5288 -17H91.6291V3H51.5288V-17ZM50.5263 5H70.5764V25H50.5263V5ZM72.5815 5H92.6316V25H72.5815V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 -18H387.368V26H345.263V-18ZM346.266 -17H386.366V3H346.266V-17ZM345.263 5H365.313V25H345.263V5ZM367.318 5H387.368V25H367.318V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 -18H429.474V26H387.368V-18ZM388.371 -17H428.471V3H388.371V-17ZM387.368 5H407.419V25H387.368V5ZM409.424 5H429.474V25H409.424V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 -18H724.211V26H682.105V-18ZM683.108 -17H723.208V3H683.108V-17ZM682.105 5H702.155V25H682.105V5ZM704.16 5H724.211V25H704.16V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 -18H766.316V26H724.211V-18ZM725.213 -17H765.313V3H725.213V-17ZM724.211 5H744.261V25H724.211V5ZM746.266 5H766.316V25H746.266V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 -18H1145.26V26H1103.16V-18ZM1104.16 -17H1144.26V3H1104.16V-17ZM1103.16 5H1123.21V25H1103.16V5ZM1125.21 5H1145.26V25H1125.21V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 -18H1187.37V26H1145.26V-18ZM1146.27 -17H1186.37V3H1146.27V-17ZM1145.26 5H1165.31V25H1145.26V5ZM1167.32 5H1187.37V25H1167.32V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 -18H1313.68V26H1271.58V-18ZM1272.58 -17H1312.68V3H1272.58V-17ZM1271.58 5H1291.63V25H1271.58V5ZM1293.63 5H1313.68V25H1293.63V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 -18H1355.79V26H1313.68V-18ZM1314.69 -17H1354.79V3H1314.69V-17ZM1313.68 5H1333.73V25H1313.68V5ZM1335.74 5H1355.79V25H1335.74V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 -18H-33.6842V26H-75.7895V-18ZM-74.787 -17H-34.6867V3H-74.787V-17ZM-75.7895 5H-55.7393V25H-75.7895V5ZM-53.7343 5H-33.6842V25H-53.7343V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 -18H8.42105V26H-33.6842V-18ZM-32.6817 -17H7.41855V3H-32.6817V-17ZM-33.6842 5H-13.6341V25H-33.6842V5ZM-11.6291 5H8.42105V25H-11.6291V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 -18H303.158V26H261.053V-18ZM262.055 -17H302.155V3H262.055V-17ZM261.053 5H281.103V25H261.053V5ZM283.108 5H303.158V25H283.108V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 -18H345.263V26H303.158V-18ZM304.16 -17H344.261V3H304.16V-17ZM303.158 5H323.208V25H303.158V5ZM325.213 5H345.263V25H325.213V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 -18H640V26H597.895V-18ZM598.897 -17H638.997V3H598.897V-17ZM597.895 5H617.945V25H597.895V5ZM619.95 5H640V25H619.95V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 -18H682.105V26H640V-18ZM641.003 -17H681.103V3H641.003V-17ZM640 5H660.05V25H640V5ZM662.055 5H682.105V25H662.055V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 -18H1061.05V26H1018.95V-18ZM1019.95 -17H1060.05V3H1019.95V-17ZM1018.95 5H1039V25H1018.95V5ZM1041 5H1061.05V25H1041V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 -18H1103.16V26H1061.05V-18ZM1062.06 -17H1102.16V3H1062.06V-17ZM1061.05 5H1081.1V25H1061.05V5ZM1083.11 5H1103.16V25H1083.11V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 -18H134.737V26H92.6316V-18ZM93.6341 -17H133.734V3H93.6341V-17ZM92.6316 5H112.682V25H92.6316V5ZM114.687 5H134.737V25H114.687V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 -18H176.842V26H134.737V-18ZM135.739 -17H175.84V3H135.739V-17ZM134.737 5H154.787V25H134.737V5ZM156.792 5H176.842V25H156.792V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 -18H471.579V26H429.474V-18ZM430.476 -17H470.576V3H430.476V-17ZM429.474 5H449.524V25H429.474V5ZM451.529 5H471.579V25H451.529V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 -18H513.684V26H471.579V-18ZM472.581 -17H512.682V3H472.581V-17ZM471.579 5H491.629V25H471.579V5ZM493.634 5H513.684V25H493.634V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 -18H892.632V26H850.526V-18ZM851.529 -17H891.629V3H851.529V-17ZM850.526 5H870.576V25H850.526V5ZM872.581 5H892.632V25H872.581V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 -18H934.737V26H892.632V-18ZM893.634 -17H933.734V3H893.634V-17ZM892.632 5H912.682V25H892.632V5ZM914.687 5H934.737V25H914.687V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 -18H808.421V26H766.316V-18ZM767.318 -17H807.419V3H767.318V-17ZM766.316 5H786.366V25H766.316V5ZM788.371 5H808.421V25H788.371V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 -18H850.526V26H808.421V-18ZM809.424 -17H849.524V3H809.424V-17ZM808.421 5H828.471V25H808.421V5ZM830.476 5H850.526V25H830.476V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 -18H1229.47V26H1187.37V-18ZM1188.37 -17H1228.47V3H1188.37V-17ZM1187.37 5H1207.42V25H1187.37V5ZM1209.42 5H1229.47V25H1209.42V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 -18H1271.58V26H1229.47V-18ZM1230.48 -17H1270.58V3H1230.48V-17ZM1229.47 5H1249.52V25H1229.47V5ZM1251.53 5H1271.58V25H1251.53V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 -18H1397.89V26H1355.79V-18ZM1356.79 -17H1396.89V3H1356.79V-17ZM1355.79 5H1375.84V25H1355.79V5ZM1377.84 5H1397.89V25H1377.84V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 -18H1440V26H1397.89V-18ZM1398.9 -17H1439V3H1398.9V-17ZM1397.89 5H1417.94V25H1397.89V5ZM1419.95 5H1440V25H1419.95V5Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 26H-117.895V70H-160V26ZM-158.997 27H-118.897V47H-158.997V27ZM-160 49H-139.95V69H-160V49ZM-137.945 49H-117.895V69H-137.945V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 26H-75.7895V70H-117.895V26ZM-116.892 27H-76.792V47H-116.892V27ZM-117.895 49H-97.8446V69H-117.895V49ZM-95.8396 49H-75.7895V69H-95.8396V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 26H218.947V70H176.842V26ZM177.845 27H217.945V47H177.845V27ZM176.842 49H196.892V69H176.842V49ZM198.897 49H218.947V69H198.897V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 26H261.053V70H218.947V26ZM219.95 27H260.05V47H219.95V27ZM218.947 49H238.997V69H218.947V49ZM241.003 49H261.053V69H241.003V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 26H555.789V70H513.684V26ZM514.687 27H554.787V47H514.687V27ZM513.684 49H533.734V69H513.684V49ZM535.739 49H555.789V69H535.739V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 26H597.895V70H555.789V26ZM556.792 27H596.892V47H556.792V27ZM555.789 49H575.84V69H555.789V49ZM577.845 49H597.895V69H577.845V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 26H976.842V70H934.737V26ZM935.739 27H975.84V47H935.739V27ZM934.737 49H954.787V69H934.737V49ZM956.792 49H976.842V69H956.792V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 26H1018.95V70H976.842V26ZM977.845 27H1017.94V47H977.845V27ZM976.842 49H996.892V69H976.842V49ZM998.897 49H1018.95V69H998.897V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 26H50.5263V70H8.42105V26ZM9.42355 27H49.5238V47H9.42355V27ZM8.42105 49H28.4712V69H8.42105V49ZM30.4762 49H50.5263V69H30.4762V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 26H92.6316V70H50.5263V26ZM51.5288 27H91.6291V47H51.5288V27ZM50.5263 49H70.5764V69H50.5263V49ZM72.5815 49H92.6316V69H72.5815V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 26H387.368V70H345.263V26ZM346.266 27H386.366V47H346.266V27ZM345.263 49H365.313V69H345.263V49ZM367.318 49H387.368V69H367.318V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 26H429.474V70H387.368V26ZM388.371 27H428.471V47H388.371V27ZM387.368 49H407.419V69H387.368V49ZM409.424 49H429.474V69H409.424V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 26H724.211V70H682.105V26ZM683.108 27H723.208V47H683.108V27ZM682.105 49H702.155V69H682.105V49ZM704.16 49H724.211V69H704.16V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 26H766.316V70H724.211V26ZM725.213 27H765.313V47H725.213V27ZM724.211 49H744.261V69H724.211V49ZM746.266 49H766.316V69H746.266V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 26H1145.26V70H1103.16V26ZM1104.16 27H1144.26V47H1104.16V27ZM1103.16 49H1123.21V69H1103.16V49ZM1125.21 49H1145.26V69H1125.21V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 26H1187.37V70H1145.26V26ZM1146.27 27H1186.37V47H1146.27V27ZM1145.26 49H1165.31V69H1145.26V49ZM1167.32 49H1187.37V69H1167.32V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 26H1313.68V70H1271.58V26ZM1272.58 27H1312.68V47H1272.58V27ZM1271.58 49H1291.63V69H1271.58V49ZM1293.63 49H1313.68V69H1293.63V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 26H1355.79V70H1313.68V26ZM1314.69 27H1354.79V47H1314.69V27ZM1313.68 49H1333.73V69H1313.68V49ZM1335.74 49H1355.79V69H1335.74V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 26H-33.6842V70H-75.7895V26ZM-74.787 27H-34.6867V47H-74.787V27ZM-75.7895 49H-55.7393V69H-75.7895V49ZM-53.7343 49H-33.6842V69H-53.7343V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 26H8.42105V70H-33.6842V26ZM-32.6817 27H7.41855V47H-32.6817V27ZM-33.6842 49H-13.6341V69H-33.6842V49ZM-11.6291 49H8.42105V69H-11.6291V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 26H303.158V70H261.053V26ZM262.055 27H302.155V47H262.055V27ZM261.053 49H281.103V69H261.053V49ZM283.108 49H303.158V69H283.108V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 26H345.263V70H303.158V26ZM304.16 27H344.261V47H304.16V27ZM303.158 49H323.208V69H303.158V49ZM325.213 49H345.263V69H325.213V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 26H640V70H597.895V26ZM598.897 27H638.997V47H598.897V27ZM597.895 49H617.945V69H597.895V49ZM619.95 49H640V69H619.95V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 26H682.105V70H640V26ZM641.003 27H681.103V47H641.003V27ZM640 49H660.05V69H640V49ZM662.055 49H682.105V69H662.055V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 26H1061.05V70H1018.95V26ZM1019.95 27H1060.05V47H1019.95V27ZM1018.95 49H1039V69H1018.95V49ZM1041 49H1061.05V69H1041V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 26H1103.16V70H1061.05V26ZM1062.06 27H1102.16V47H1062.06V27ZM1061.05 49H1081.1V69H1061.05V49ZM1083.11 49H1103.16V69H1083.11V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 26H134.737V70H92.6316V26ZM93.6341 27H133.734V47H93.6341V27ZM92.6316 49H112.682V69H92.6316V49ZM114.687 49H134.737V69H114.687V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 26H176.842V70H134.737V26ZM135.739 27H175.84V47H135.739V27ZM134.737 49H154.787V69H134.737V49ZM156.792 49H176.842V69H156.792V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 26H471.579V70H429.474V26ZM430.476 27H470.576V47H430.476V27ZM429.474 49H449.524V69H429.474V49ZM451.529 49H471.579V69H451.529V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 26H513.684V70H471.579V26ZM472.581 27H512.682V47H472.581V27ZM471.579 49H491.629V69H471.579V49ZM493.634 49H513.684V69H493.634V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 26H892.632V70H850.526V26ZM851.529 27H891.629V47H851.529V27ZM850.526 49H870.576V69H850.526V49ZM872.581 49H892.632V69H872.581V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 26H934.737V70H892.632V26ZM893.634 27H933.734V47H893.634V27ZM892.632 49H912.682V69H892.632V49ZM914.687 49H934.737V69H914.687V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 26H808.421V70H766.316V26ZM767.318 27H807.419V47H767.318V27ZM766.316 49H786.366V69H766.316V49ZM788.371 49H808.421V69H788.371V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 26H850.526V70H808.421V26ZM809.424 27H849.524V47H809.424V27ZM808.421 49H828.471V69H808.421V49ZM830.476 49H850.526V69H830.476V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 26H1229.47V70H1187.37V26ZM1188.37 27H1228.47V47H1188.37V27ZM1187.37 49H1207.42V69H1187.37V49ZM1209.42 49H1229.47V69H1209.42V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 26H1271.58V70H1229.47V26ZM1230.48 27H1270.58V47H1230.48V27ZM1229.47 49H1249.52V69H1229.47V49ZM1251.53 49H1271.58V69H1251.53V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 26H1397.89V70H1355.79V26ZM1356.79 27H1396.89V47H1356.79V27ZM1355.79 49H1375.84V69H1355.79V49ZM1377.84 49H1397.89V69H1377.84V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 26H1440V70H1397.89V26ZM1398.9 27H1439V47H1398.9V27ZM1397.89 49H1417.94V69H1397.89V49ZM1419.95 49H1440V69H1419.95V49Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 70H-117.895V114H-160V70ZM-158.997 71H-118.897V91H-158.997V71ZM-160 93H-139.95V113H-160V93ZM-137.945 93H-117.895V113H-137.945V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 70H-75.7895V114H-117.895V70ZM-116.892 71H-76.792V91H-116.892V71ZM-117.895 93H-97.8446V113H-117.895V93ZM-95.8396 93H-75.7895V113H-95.8396V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 70H218.947V114H176.842V70ZM177.845 71H217.945V91H177.845V71ZM176.842 93H196.892V113H176.842V93ZM198.897 93H218.947V113H198.897V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 70H261.053V114H218.947V70ZM219.95 71H260.05V91H219.95V71ZM218.947 93H238.997V113H218.947V93ZM241.003 93H261.053V113H241.003V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 70H555.789V114H513.684V70ZM514.687 71H554.787V91H514.687V71ZM513.684 93H533.734V113H513.684V93ZM535.739 93H555.789V113H535.739V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 70H597.895V114H555.789V70ZM556.792 71H596.892V91H556.792V71ZM555.789 93H575.84V113H555.789V93ZM577.845 93H597.895V113H577.845V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 70H976.842V114H934.737V70ZM935.739 71H975.84V91H935.739V71ZM934.737 93H954.787V113H934.737V93ZM956.792 93H976.842V113H956.792V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 70H1018.95V114H976.842V70ZM977.845 71H1017.94V91H977.845V71ZM976.842 93H996.892V113H976.842V93ZM998.897 93H1018.95V113H998.897V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 70H50.5263V114H8.42105V70ZM9.42355 71H49.5238V91H9.42355V71ZM8.42105 93H28.4712V113H8.42105V93ZM30.4762 93H50.5263V113H30.4762V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 70H92.6316V114H50.5263V70ZM51.5288 71H91.6291V91H51.5288V71ZM50.5263 93H70.5764V113H50.5263V93ZM72.5815 93H92.6316V113H72.5815V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 70H387.368V114H345.263V70ZM346.266 71H386.366V91H346.266V71ZM345.263 93H365.313V113H345.263V93ZM367.318 93H387.368V113H367.318V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 70H429.474V114H387.368V70ZM388.371 71H428.471V91H388.371V71ZM387.368 93H407.419V113H387.368V93ZM409.424 93H429.474V113H409.424V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 70H724.211V114H682.105V70ZM683.108 71H723.208V91H683.108V71ZM682.105 93H702.155V113H682.105V93ZM704.16 93H724.211V113H704.16V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 70H766.316V114H724.211V70ZM725.213 71H765.313V91H725.213V71ZM724.211 93H744.261V113H724.211V93ZM746.266 93H766.316V113H746.266V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 70H1145.26V114H1103.16V70ZM1104.16 71H1144.26V91H1104.16V71ZM1103.16 93H1123.21V113H1103.16V93ZM1125.21 93H1145.26V113H1125.21V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 70H1187.37V114H1145.26V70ZM1146.27 71H1186.37V91H1146.27V71ZM1145.26 93H1165.31V113H1145.26V93ZM1167.32 93H1187.37V113H1167.32V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 70H1313.68V114H1271.58V70ZM1272.58 71H1312.68V91H1272.58V71ZM1271.58 93H1291.63V113H1271.58V93ZM1293.63 93H1313.68V113H1293.63V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 70H1355.79V114H1313.68V70ZM1314.69 71H1354.79V91H1314.69V71ZM1313.68 93H1333.73V113H1313.68V93ZM1335.74 93H1355.79V113H1335.74V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 70H-33.6842V114H-75.7895V70ZM-74.787 71H-34.6867V91H-74.787V71ZM-75.7895 93H-55.7393V113H-75.7895V93ZM-53.7343 93H-33.6842V113H-53.7343V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 70H8.42105V114H-33.6842V70ZM-32.6817 71H7.41855V91H-32.6817V71ZM-33.6842 93H-13.6341V113H-33.6842V93ZM-11.6291 93H8.42105V113H-11.6291V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 70H303.158V114H261.053V70ZM262.055 71H302.155V91H262.055V71ZM261.053 93H281.103V113H261.053V93ZM283.108 93H303.158V113H283.108V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 70H345.263V114H303.158V70ZM304.16 71H344.261V91H304.16V71ZM303.158 93H323.208V113H303.158V93ZM325.213 93H345.263V113H325.213V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 70H640V114H597.895V70ZM598.897 71H638.997V91H598.897V71ZM597.895 93H617.945V113H597.895V93ZM619.95 93H640V113H619.95V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 70H682.105V114H640V70ZM641.003 71H681.103V91H641.003V71ZM640 93H660.05V113H640V93ZM662.055 93H682.105V113H662.055V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 70H1061.05V114H1018.95V70ZM1019.95 71H1060.05V91H1019.95V71ZM1018.95 93H1039V113H1018.95V93ZM1041 93H1061.05V113H1041V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 70H1103.16V114H1061.05V70ZM1062.06 71H1102.16V91H1062.06V71ZM1061.05 93H1081.1V113H1061.05V93ZM1083.11 93H1103.16V113H1083.11V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 70H134.737V114H92.6316V70ZM93.6341 71H133.734V91H93.6341V71ZM92.6316 93H112.682V113H92.6316V93ZM114.687 93H134.737V113H114.687V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 70H176.842V114H134.737V70ZM135.739 71H175.84V91H135.739V71ZM134.737 93H154.787V113H134.737V93ZM156.792 93H176.842V113H156.792V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 70H471.579V114H429.474V70ZM430.476 71H470.576V91H430.476V71ZM429.474 93H449.524V113H429.474V93ZM451.529 93H471.579V113H451.529V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 70H513.684V114H471.579V70ZM472.581 71H512.682V91H472.581V71ZM471.579 93H491.629V113H471.579V93ZM493.634 93H513.684V113H493.634V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 70H892.632V114H850.526V70ZM851.529 71H891.629V91H851.529V71ZM850.526 93H870.576V113H850.526V93ZM872.581 93H892.632V113H872.581V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 70H934.737V114H892.632V70ZM893.634 71H933.734V91H893.634V71ZM892.632 93H912.682V113H892.632V93ZM914.687 93H934.737V113H914.687V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 70H808.421V114H766.316V70ZM767.318 71H807.419V91H767.318V71ZM766.316 93H786.366V113H766.316V93ZM788.371 93H808.421V113H788.371V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 70H850.526V114H808.421V70ZM809.424 71H849.524V91H809.424V71ZM808.421 93H828.471V113H808.421V93ZM830.476 93H850.526V113H830.476V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 70H1229.47V114H1187.37V70ZM1188.37 71H1228.47V91H1188.37V71ZM1187.37 93H1207.42V113H1187.37V93ZM1209.42 93H1229.47V113H1209.42V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 70H1271.58V114H1229.47V70ZM1230.48 71H1270.58V91H1230.48V71ZM1229.47 93H1249.52V113H1229.47V93ZM1251.53 93H1271.58V113H1251.53V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 70H1397.89V114H1355.79V70ZM1356.79 71H1396.89V91H1356.79V71ZM1355.79 93H1375.84V113H1355.79V93ZM1377.84 93H1397.89V113H1377.84V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 70H1440V114H1397.89V70ZM1398.9 71H1439V91H1398.9V71ZM1397.89 93H1417.94V113H1397.89V93ZM1419.95 93H1440V113H1419.95V93Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 114H-117.895V158H-160V114ZM-158.997 115H-118.897V135H-158.997V115ZM-160 137H-139.95V157H-160V137ZM-137.945 137H-117.895V157H-137.945V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 114H-75.7895V158H-117.895V114ZM-116.892 115H-76.792V135H-116.892V115ZM-117.895 137H-97.8446V157H-117.895V137ZM-95.8396 137H-75.7895V157H-95.8396V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 114H218.947V158H176.842V114ZM177.845 115H217.945V135H177.845V115ZM176.842 137H196.892V157H176.842V137ZM198.897 137H218.947V157H198.897V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 114H261.053V158H218.947V114ZM219.95 115H260.05V135H219.95V115ZM218.947 137H238.997V157H218.947V137ZM241.003 137H261.053V157H241.003V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 114H555.789V158H513.684V114ZM514.687 115H554.787V135H514.687V115ZM513.684 137H533.734V157H513.684V137ZM535.739 137H555.789V157H535.739V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 114H597.895V158H555.789V114ZM556.792 115H596.892V135H556.792V115ZM555.789 137H575.84V157H555.789V137ZM577.845 137H597.895V157H577.845V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 114H976.842V158H934.737V114ZM935.739 115H975.84V135H935.739V115ZM934.737 137H954.787V157H934.737V137ZM956.792 137H976.842V157H956.792V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 114H1018.95V158H976.842V114ZM977.845 115H1017.94V135H977.845V115ZM976.842 137H996.892V157H976.842V137ZM998.897 137H1018.95V157H998.897V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 114H50.5263V158H8.42105V114ZM9.42355 115H49.5238V135H9.42355V115ZM8.42105 137H28.4712V157H8.42105V137ZM30.4762 137H50.5263V157H30.4762V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 114H92.6316V158H50.5263V114ZM51.5288 115H91.6291V135H51.5288V115ZM50.5263 137H70.5764V157H50.5263V137ZM72.5815 137H92.6316V157H72.5815V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 114H387.368V158H345.263V114ZM346.266 115H386.366V135H346.266V115ZM345.263 137H365.313V157H345.263V137ZM367.318 137H387.368V157H367.318V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 114H429.474V158H387.368V114ZM388.371 115H428.471V135H388.371V115ZM387.368 137H407.419V157H387.368V137ZM409.424 137H429.474V157H409.424V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 114H724.211V158H682.105V114ZM683.108 115H723.208V135H683.108V115ZM682.105 137H702.155V157H682.105V137ZM704.16 137H724.211V157H704.16V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 114H766.316V158H724.211V114ZM725.213 115H765.313V135H725.213V115ZM724.211 137H744.261V157H724.211V137ZM746.266 137H766.316V157H746.266V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 114H1145.26V158H1103.16V114ZM1104.16 115H1144.26V135H1104.16V115ZM1103.16 137H1123.21V157H1103.16V137ZM1125.21 137H1145.26V157H1125.21V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 114H1187.37V158H1145.26V114ZM1146.27 115H1186.37V135H1146.27V115ZM1145.26 137H1165.31V157H1145.26V137ZM1167.32 137H1187.37V157H1167.32V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 114H1313.68V158H1271.58V114ZM1272.58 115H1312.68V135H1272.58V115ZM1271.58 137H1291.63V157H1271.58V137ZM1293.63 137H1313.68V157H1293.63V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 114H1355.79V158H1313.68V114ZM1314.69 115H1354.79V135H1314.69V115ZM1313.68 137H1333.73V157H1313.68V137ZM1335.74 137H1355.79V157H1335.74V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 114H-33.6842V158H-75.7895V114ZM-74.787 115H-34.6867V135H-74.787V115ZM-75.7895 137H-55.7393V157H-75.7895V137ZM-53.7343 137H-33.6842V157H-53.7343V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 114H8.42105V158H-33.6842V114ZM-32.6817 115H7.41855V135H-32.6817V115ZM-33.6842 137H-13.6341V157H-33.6842V137ZM-11.6291 137H8.42105V157H-11.6291V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 114H303.158V158H261.053V114ZM262.055 115H302.155V135H262.055V115ZM261.053 137H281.103V157H261.053V137ZM283.108 137H303.158V157H283.108V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 114H345.263V158H303.158V114ZM304.16 115H344.261V135H304.16V115ZM303.158 137H323.208V157H303.158V137ZM325.213 137H345.263V157H325.213V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 114H640V158H597.895V114ZM598.897 115H638.997V135H598.897V115ZM597.895 137H617.945V157H597.895V137ZM619.95 137H640V157H619.95V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 114H682.105V158H640V114ZM641.003 115H681.103V135H641.003V115ZM640 137H660.05V157H640V137ZM662.055 137H682.105V157H662.055V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 114H1061.05V158H1018.95V114ZM1019.95 115H1060.05V135H1019.95V115ZM1018.95 137H1039V157H1018.95V137ZM1041 137H1061.05V157H1041V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 114H1103.16V158H1061.05V114ZM1062.06 115H1102.16V135H1062.06V115ZM1061.05 137H1081.1V157H1061.05V137ZM1083.11 137H1103.16V157H1083.11V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 114H134.737V158H92.6316V114ZM93.6341 115H133.734V135H93.6341V115ZM92.6316 137H112.682V157H92.6316V137ZM114.687 137H134.737V157H114.687V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 114H176.842V158H134.737V114ZM135.739 115H175.84V135H135.739V115ZM134.737 137H154.787V157H134.737V137ZM156.792 137H176.842V157H156.792V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 114H471.579V158H429.474V114ZM430.476 115H470.576V135H430.476V115ZM429.474 137H449.524V157H429.474V137ZM451.529 137H471.579V157H451.529V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 114H513.684V158H471.579V114ZM472.581 115H512.682V135H472.581V115ZM471.579 137H491.629V157H471.579V137ZM493.634 137H513.684V157H493.634V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 114H892.632V158H850.526V114ZM851.529 115H891.629V135H851.529V115ZM850.526 137H870.576V157H850.526V137ZM872.581 137H892.632V157H872.581V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 114H934.737V158H892.632V114ZM893.634 115H933.734V135H893.634V115ZM892.632 137H912.682V157H892.632V137ZM914.687 137H934.737V157H914.687V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 114H808.421V158H766.316V114ZM767.318 115H807.419V135H767.318V115ZM766.316 137H786.366V157H766.316V137ZM788.371 137H808.421V157H788.371V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 114H850.526V158H808.421V114ZM809.424 115H849.524V135H809.424V115ZM808.421 137H828.471V157H808.421V137ZM830.476 137H850.526V157H830.476V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 114H1229.47V158H1187.37V114ZM1188.37 115H1228.47V135H1188.37V115ZM1187.37 137H1207.42V157H1187.37V137ZM1209.42 137H1229.47V157H1209.42V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 114H1271.58V158H1229.47V114ZM1230.48 115H1270.58V135H1230.48V115ZM1229.47 137H1249.52V157H1229.47V137ZM1251.53 137H1271.58V157H1251.53V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 114H1397.89V158H1355.79V114ZM1356.79 115H1396.89V135H1356.79V115ZM1355.79 137H1375.84V157H1355.79V137ZM1377.84 137H1397.89V157H1377.84V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 114H1440V158H1397.89V114ZM1398.9 115H1439V135H1398.9V115ZM1397.89 137H1417.94V157H1397.89V137ZM1419.95 137H1440V157H1419.95V137Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 158H-117.895V202H-160V158ZM-158.997 159H-118.897V179H-158.997V159ZM-160 181H-139.95V201H-160V181ZM-137.945 181H-117.895V201H-137.945V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 158H-75.7895V202H-117.895V158ZM-116.892 159H-76.792V179H-116.892V159ZM-117.895 181H-97.8446V201H-117.895V181ZM-95.8396 181H-75.7895V201H-95.8396V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 158H218.947V202H176.842V158ZM177.845 159H217.945V179H177.845V159ZM176.842 181H196.892V201H176.842V181ZM198.897 181H218.947V201H198.897V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 158H261.053V202H218.947V158ZM219.95 159H260.05V179H219.95V159ZM218.947 181H238.997V201H218.947V181ZM241.003 181H261.053V201H241.003V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 158H555.789V202H513.684V158ZM514.687 159H554.787V179H514.687V159ZM513.684 181H533.734V201H513.684V181ZM535.739 181H555.789V201H535.739V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 158H597.895V202H555.789V158ZM556.792 159H596.892V179H556.792V159ZM555.789 181H575.84V201H555.789V181ZM577.845 181H597.895V201H577.845V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 158H976.842V202H934.737V158ZM935.739 159H975.84V179H935.739V159ZM934.737 181H954.787V201H934.737V181ZM956.792 181H976.842V201H956.792V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 158H1018.95V202H976.842V158ZM977.845 159H1017.94V179H977.845V159ZM976.842 181H996.892V201H976.842V181ZM998.897 181H1018.95V201H998.897V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 158H50.5263V202H8.42105V158ZM9.42355 159H49.5238V179H9.42355V159ZM8.42105 181H28.4712V201H8.42105V181ZM30.4762 181H50.5263V201H30.4762V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 158H92.6316V202H50.5263V158ZM51.5288 159H91.6291V179H51.5288V159ZM50.5263 181H70.5764V201H50.5263V181ZM72.5815 181H92.6316V201H72.5815V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 158H387.368V202H345.263V158ZM346.266 159H386.366V179H346.266V159ZM345.263 181H365.313V201H345.263V181ZM367.318 181H387.368V201H367.318V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 158H429.474V202H387.368V158ZM388.371 159H428.471V179H388.371V159ZM387.368 181H407.419V201H387.368V181ZM409.424 181H429.474V201H409.424V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 158H724.211V202H682.105V158ZM683.108 159H723.208V179H683.108V159ZM682.105 181H702.155V201H682.105V181ZM704.16 181H724.211V201H704.16V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 158H766.316V202H724.211V158ZM725.213 159H765.313V179H725.213V159ZM724.211 181H744.261V201H724.211V181ZM746.266 181H766.316V201H746.266V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 158H1145.26V202H1103.16V158ZM1104.16 159H1144.26V179H1104.16V159ZM1103.16 181H1123.21V201H1103.16V181ZM1125.21 181H1145.26V201H1125.21V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 158H1187.37V202H1145.26V158ZM1146.27 159H1186.37V179H1146.27V159ZM1145.26 181H1165.31V201H1145.26V181ZM1167.32 181H1187.37V201H1167.32V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 158H1313.68V202H1271.58V158ZM1272.58 159H1312.68V179H1272.58V159ZM1271.58 181H1291.63V201H1271.58V181ZM1293.63 181H1313.68V201H1293.63V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 158H1355.79V202H1313.68V158ZM1314.69 159H1354.79V179H1314.69V159ZM1313.68 181H1333.73V201H1313.68V181ZM1335.74 181H1355.79V201H1335.74V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 158H-33.6842V202H-75.7895V158ZM-74.787 159H-34.6867V179H-74.787V159ZM-75.7895 181H-55.7393V201H-75.7895V181ZM-53.7343 181H-33.6842V201H-53.7343V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 158H8.42105V202H-33.6842V158ZM-32.6817 159H7.41855V179H-32.6817V159ZM-33.6842 181H-13.6341V201H-33.6842V181ZM-11.6291 181H8.42105V201H-11.6291V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 158H303.158V202H261.053V158ZM262.055 159H302.155V179H262.055V159ZM261.053 181H281.103V201H261.053V181ZM283.108 181H303.158V201H283.108V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 158H345.263V202H303.158V158ZM304.16 159H344.261V179H304.16V159ZM303.158 181H323.208V201H303.158V181ZM325.213 181H345.263V201H325.213V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 158H640V202H597.895V158ZM598.897 159H638.997V179H598.897V159ZM597.895 181H617.945V201H597.895V181ZM619.95 181H640V201H619.95V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 158H682.105V202H640V158ZM641.003 159H681.103V179H641.003V159ZM640 181H660.05V201H640V181ZM662.055 181H682.105V201H662.055V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 158H1061.05V202H1018.95V158ZM1019.95 159H1060.05V179H1019.95V159ZM1018.95 181H1039V201H1018.95V181ZM1041 181H1061.05V201H1041V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 158H1103.16V202H1061.05V158ZM1062.06 159H1102.16V179H1062.06V159ZM1061.05 181H1081.1V201H1061.05V181ZM1083.11 181H1103.16V201H1083.11V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 158H134.737V202H92.6316V158ZM93.6341 159H133.734V179H93.6341V159ZM92.6316 181H112.682V201H92.6316V181ZM114.687 181H134.737V201H114.687V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 158H176.842V202H134.737V158ZM135.739 159H175.84V179H135.739V159ZM134.737 181H154.787V201H134.737V181ZM156.792 181H176.842V201H156.792V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 158H471.579V202H429.474V158ZM430.476 159H470.576V179H430.476V159ZM429.474 181H449.524V201H429.474V181ZM451.529 181H471.579V201H451.529V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 158H513.684V202H471.579V158ZM472.581 159H512.682V179H472.581V159ZM471.579 181H491.629V201H471.579V181ZM493.634 181H513.684V201H493.634V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 158H892.632V202H850.526V158ZM851.529 159H891.629V179H851.529V159ZM850.526 181H870.576V201H850.526V181ZM872.581 181H892.632V201H872.581V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 158H934.737V202H892.632V158ZM893.634 159H933.734V179H893.634V159ZM892.632 181H912.682V201H892.632V181ZM914.687 181H934.737V201H914.687V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 158H808.421V202H766.316V158ZM767.318 159H807.419V179H767.318V159ZM766.316 181H786.366V201H766.316V181ZM788.371 181H808.421V201H788.371V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 158H850.526V202H808.421V158ZM809.424 159H849.524V179H809.424V159ZM808.421 181H828.471V201H808.421V181ZM830.476 181H850.526V201H830.476V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 158H1229.47V202H1187.37V158ZM1188.37 159H1228.47V179H1188.37V159ZM1187.37 181H1207.42V201H1187.37V181ZM1209.42 181H1229.47V201H1209.42V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 158H1271.58V202H1229.47V158ZM1230.48 159H1270.58V179H1230.48V159ZM1229.47 181H1249.52V201H1229.47V181ZM1251.53 181H1271.58V201H1251.53V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 158H1397.89V202H1355.79V158ZM1356.79 159H1396.89V179H1356.79V159ZM1355.79 181H1375.84V201H1355.79V181ZM1377.84 181H1397.89V201H1377.84V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 158H1440V202H1397.89V158ZM1398.9 159H1439V179H1398.9V159ZM1397.89 181H1417.94V201H1397.89V181ZM1419.95 181H1440V201H1419.95V181Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 202H-117.895V246H-160V202ZM-158.997 203H-118.897V223H-158.997V203ZM-160 225H-139.95V245H-160V225ZM-137.945 225H-117.895V245H-137.945V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 202H-75.7895V246H-117.895V202ZM-116.892 203H-76.792V223H-116.892V203ZM-117.895 225H-97.8446V245H-117.895V225ZM-95.8396 225H-75.7895V245H-95.8396V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 202H218.947V246H176.842V202ZM177.845 203H217.945V223H177.845V203ZM176.842 225H196.892V245H176.842V225ZM198.897 225H218.947V245H198.897V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 202H261.053V246H218.947V202ZM219.95 203H260.05V223H219.95V203ZM218.947 225H238.997V245H218.947V225ZM241.003 225H261.053V245H241.003V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 202H555.789V246H513.684V202ZM514.687 203H554.787V223H514.687V203ZM513.684 225H533.734V245H513.684V225ZM535.739 225H555.789V245H535.739V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 202H597.895V246H555.789V202ZM556.792 203H596.892V223H556.792V203ZM555.789 225H575.84V245H555.789V225ZM577.845 225H597.895V245H577.845V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 202H976.842V246H934.737V202ZM935.739 203H975.84V223H935.739V203ZM934.737 225H954.787V245H934.737V225ZM956.792 225H976.842V245H956.792V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 202H1018.95V246H976.842V202ZM977.845 203H1017.94V223H977.845V203ZM976.842 225H996.892V245H976.842V225ZM998.897 225H1018.95V245H998.897V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 202H50.5263V246H8.42105V202ZM9.42355 203H49.5238V223H9.42355V203ZM8.42105 225H28.4712V245H8.42105V225ZM30.4762 225H50.5263V245H30.4762V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 202H92.6316V246H50.5263V202ZM51.5288 203H91.6291V223H51.5288V203ZM50.5263 225H70.5764V245H50.5263V225ZM72.5815 225H92.6316V245H72.5815V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 202H387.368V246H345.263V202ZM346.266 203H386.366V223H346.266V203ZM345.263 225H365.313V245H345.263V225ZM367.318 225H387.368V245H367.318V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 202H429.474V246H387.368V202ZM388.371 203H428.471V223H388.371V203ZM387.368 225H407.419V245H387.368V225ZM409.424 225H429.474V245H409.424V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 202H724.211V246H682.105V202ZM683.108 203H723.208V223H683.108V203ZM682.105 225H702.155V245H682.105V225ZM704.16 225H724.211V245H704.16V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 202H766.316V246H724.211V202ZM725.213 203H765.313V223H725.213V203ZM724.211 225H744.261V245H724.211V225ZM746.266 225H766.316V245H746.266V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 202H1145.26V246H1103.16V202ZM1104.16 203H1144.26V223H1104.16V203ZM1103.16 225H1123.21V245H1103.16V225ZM1125.21 225H1145.26V245H1125.21V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 202H1187.37V246H1145.26V202ZM1146.27 203H1186.37V223H1146.27V203ZM1145.26 225H1165.31V245H1145.26V225ZM1167.32 225H1187.37V245H1167.32V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 202H1313.68V246H1271.58V202ZM1272.58 203H1312.68V223H1272.58V203ZM1271.58 225H1291.63V245H1271.58V225ZM1293.63 225H1313.68V245H1293.63V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 202H1355.79V246H1313.68V202ZM1314.69 203H1354.79V223H1314.69V203ZM1313.68 225H1333.73V245H1313.68V225ZM1335.74 225H1355.79V245H1335.74V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 202H-33.6842V246H-75.7895V202ZM-74.787 203H-34.6867V223H-74.787V203ZM-75.7895 225H-55.7393V245H-75.7895V225ZM-53.7343 225H-33.6842V245H-53.7343V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 202H8.42105V246H-33.6842V202ZM-32.6817 203H7.41855V223H-32.6817V203ZM-33.6842 225H-13.6341V245H-33.6842V225ZM-11.6291 225H8.42105V245H-11.6291V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 202H303.158V246H261.053V202ZM262.055 203H302.155V223H262.055V203ZM261.053 225H281.103V245H261.053V225ZM283.108 225H303.158V245H283.108V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 202H345.263V246H303.158V202ZM304.16 203H344.261V223H304.16V203ZM303.158 225H323.208V245H303.158V225ZM325.213 225H345.263V245H325.213V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 202H640V246H597.895V202ZM598.897 203H638.997V223H598.897V203ZM597.895 225H617.945V245H597.895V225ZM619.95 225H640V245H619.95V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 202H682.105V246H640V202ZM641.003 203H681.103V223H641.003V203ZM640 225H660.05V245H640V225ZM662.055 225H682.105V245H662.055V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 202H1061.05V246H1018.95V202ZM1019.95 203H1060.05V223H1019.95V203ZM1018.95 225H1039V245H1018.95V225ZM1041 225H1061.05V245H1041V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 202H1103.16V246H1061.05V202ZM1062.06 203H1102.16V223H1062.06V203ZM1061.05 225H1081.1V245H1061.05V225ZM1083.11 225H1103.16V245H1083.11V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 202H134.737V246H92.6316V202ZM93.6341 203H133.734V223H93.6341V203ZM92.6316 225H112.682V245H92.6316V225ZM114.687 225H134.737V245H114.687V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 202H176.842V246H134.737V202ZM135.739 203H175.84V223H135.739V203ZM134.737 225H154.787V245H134.737V225ZM156.792 225H176.842V245H156.792V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 202H471.579V246H429.474V202ZM430.476 203H470.576V223H430.476V203ZM429.474 225H449.524V245H429.474V225ZM451.529 225H471.579V245H451.529V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 202H513.684V246H471.579V202ZM472.581 203H512.682V223H472.581V203ZM471.579 225H491.629V245H471.579V225ZM493.634 225H513.684V245H493.634V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 202H892.632V246H850.526V202ZM851.529 203H891.629V223H851.529V203ZM850.526 225H870.576V245H850.526V225ZM872.581 225H892.632V245H872.581V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 202H934.737V246H892.632V202ZM893.634 203H933.734V223H893.634V203ZM892.632 225H912.682V245H892.632V225ZM914.687 225H934.737V245H914.687V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 202H808.421V246H766.316V202ZM767.318 203H807.419V223H767.318V203ZM766.316 225H786.366V245H766.316V225ZM788.371 225H808.421V245H788.371V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 202H850.526V246H808.421V202ZM809.424 203H849.524V223H809.424V203ZM808.421 225H828.471V245H808.421V225ZM830.476 225H850.526V245H830.476V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 202H1229.47V246H1187.37V202ZM1188.37 203H1228.47V223H1188.37V203ZM1187.37 225H1207.42V245H1187.37V225ZM1209.42 225H1229.47V245H1209.42V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 202H1271.58V246H1229.47V202ZM1230.48 203H1270.58V223H1230.48V203ZM1229.47 225H1249.52V245H1229.47V225ZM1251.53 225H1271.58V245H1251.53V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 202H1397.89V246H1355.79V202ZM1356.79 203H1396.89V223H1356.79V203ZM1355.79 225H1375.84V245H1355.79V225ZM1377.84 225H1397.89V245H1377.84V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 202H1440V246H1397.89V202ZM1398.9 203H1439V223H1398.9V203ZM1397.89 225H1417.94V245H1397.89V225ZM1419.95 225H1440V245H1419.95V225Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 246H-117.895V290H-160V246ZM-158.997 247H-118.897V267H-158.997V247ZM-160 269H-139.95V289H-160V269ZM-137.945 269H-117.895V289H-137.945V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 246H-75.7895V290H-117.895V246ZM-116.892 247H-76.792V267H-116.892V247ZM-117.895 269H-97.8446V289H-117.895V269ZM-95.8396 269H-75.7895V289H-95.8396V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 246H218.947V290H176.842V246ZM177.845 247H217.945V267H177.845V247ZM176.842 269H196.892V289H176.842V269ZM198.897 269H218.947V289H198.897V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 246H261.053V290H218.947V246ZM219.95 247H260.05V267H219.95V247ZM218.947 269H238.997V289H218.947V269ZM241.003 269H261.053V289H241.003V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 246H555.789V290H513.684V246ZM514.687 247H554.787V267H514.687V247ZM513.684 269H533.734V289H513.684V269ZM535.739 269H555.789V289H535.739V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 246H597.895V290H555.789V246ZM556.792 247H596.892V267H556.792V247ZM555.789 269H575.84V289H555.789V269ZM577.845 269H597.895V289H577.845V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 246H976.842V290H934.737V246ZM935.739 247H975.84V267H935.739V247ZM934.737 269H954.787V289H934.737V269ZM956.792 269H976.842V289H956.792V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 246H1018.95V290H976.842V246ZM977.845 247H1017.94V267H977.845V247ZM976.842 269H996.892V289H976.842V269ZM998.897 269H1018.95V289H998.897V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 246H50.5263V290H8.42105V246ZM9.42355 247H49.5238V267H9.42355V247ZM8.42105 269H28.4712V289H8.42105V269ZM30.4762 269H50.5263V289H30.4762V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 246H92.6316V290H50.5263V246ZM51.5288 247H91.6291V267H51.5288V247ZM50.5263 269H70.5764V289H50.5263V269ZM72.5815 269H92.6316V289H72.5815V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 246H387.368V290H345.263V246ZM346.266 247H386.366V267H346.266V247ZM345.263 269H365.313V289H345.263V269ZM367.318 269H387.368V289H367.318V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 246H429.474V290H387.368V246ZM388.371 247H428.471V267H388.371V247ZM387.368 269H407.419V289H387.368V269ZM409.424 269H429.474V289H409.424V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 246H724.211V290H682.105V246ZM683.108 247H723.208V267H683.108V247ZM682.105 269H702.155V289H682.105V269ZM704.16 269H724.211V289H704.16V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 246H766.316V290H724.211V246ZM725.213 247H765.313V267H725.213V247ZM724.211 269H744.261V289H724.211V269ZM746.266 269H766.316V289H746.266V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 246H1145.26V290H1103.16V246ZM1104.16 247H1144.26V267H1104.16V247ZM1103.16 269H1123.21V289H1103.16V269ZM1125.21 269H1145.26V289H1125.21V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 246H1187.37V290H1145.26V246ZM1146.27 247H1186.37V267H1146.27V247ZM1145.26 269H1165.31V289H1145.26V269ZM1167.32 269H1187.37V289H1167.32V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 246H1313.68V290H1271.58V246ZM1272.58 247H1312.68V267H1272.58V247ZM1271.58 269H1291.63V289H1271.58V269ZM1293.63 269H1313.68V289H1293.63V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 246H1355.79V290H1313.68V246ZM1314.69 247H1354.79V267H1314.69V247ZM1313.68 269H1333.73V289H1313.68V269ZM1335.74 269H1355.79V289H1335.74V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 246H-33.6842V290H-75.7895V246ZM-74.787 247H-34.6867V267H-74.787V247ZM-75.7895 269H-55.7393V289H-75.7895V269ZM-53.7343 269H-33.6842V289H-53.7343V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 246H8.42105V290H-33.6842V246ZM-32.6817 247H7.41855V267H-32.6817V247ZM-33.6842 269H-13.6341V289H-33.6842V269ZM-11.6291 269H8.42105V289H-11.6291V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 246H303.158V290H261.053V246ZM262.055 247H302.155V267H262.055V247ZM261.053 269H281.103V289H261.053V269ZM283.108 269H303.158V289H283.108V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 246H345.263V290H303.158V246ZM304.16 247H344.261V267H304.16V247ZM303.158 269H323.208V289H303.158V269ZM325.213 269H345.263V289H325.213V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 246H640V290H597.895V246ZM598.897 247H638.997V267H598.897V247ZM597.895 269H617.945V289H597.895V269ZM619.95 269H640V289H619.95V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 246H682.105V290H640V246ZM641.003 247H681.103V267H641.003V247ZM640 269H660.05V289H640V269ZM662.055 269H682.105V289H662.055V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 246H1061.05V290H1018.95V246ZM1019.95 247H1060.05V267H1019.95V247ZM1018.95 269H1039V289H1018.95V269ZM1041 269H1061.05V289H1041V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 246H1103.16V290H1061.05V246ZM1062.06 247H1102.16V267H1062.06V247ZM1061.05 269H1081.1V289H1061.05V269ZM1083.11 269H1103.16V289H1083.11V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 246H134.737V290H92.6316V246ZM93.6341 247H133.734V267H93.6341V247ZM92.6316 269H112.682V289H92.6316V269ZM114.687 269H134.737V289H114.687V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 246H176.842V290H134.737V246ZM135.739 247H175.84V267H135.739V247ZM134.737 269H154.787V289H134.737V269ZM156.792 269H176.842V289H156.792V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 246H471.579V290H429.474V246ZM430.476 247H470.576V267H430.476V247ZM429.474 269H449.524V289H429.474V269ZM451.529 269H471.579V289H451.529V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 246H513.684V290H471.579V246ZM472.581 247H512.682V267H472.581V247ZM471.579 269H491.629V289H471.579V269ZM493.634 269H513.684V289H493.634V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 246H892.632V290H850.526V246ZM851.529 247H891.629V267H851.529V247ZM850.526 269H870.576V289H850.526V269ZM872.581 269H892.632V289H872.581V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 246H934.737V290H892.632V246ZM893.634 247H933.734V267H893.634V247ZM892.632 269H912.682V289H892.632V269ZM914.687 269H934.737V289H914.687V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 246H808.421V290H766.316V246ZM767.318 247H807.419V267H767.318V247ZM766.316 269H786.366V289H766.316V269ZM788.371 269H808.421V289H788.371V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 246H850.526V290H808.421V246ZM809.424 247H849.524V267H809.424V247ZM808.421 269H828.471V289H808.421V269ZM830.476 269H850.526V289H830.476V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 246H1229.47V290H1187.37V246ZM1188.37 247H1228.47V267H1188.37V247ZM1187.37 269H1207.42V289H1187.37V269ZM1209.42 269H1229.47V289H1209.42V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 246H1271.58V290H1229.47V246ZM1230.48 247H1270.58V267H1230.48V247ZM1229.47 269H1249.52V289H1229.47V269ZM1251.53 269H1271.58V289H1251.53V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 246H1397.89V290H1355.79V246ZM1356.79 247H1396.89V267H1356.79V247ZM1355.79 269H1375.84V289H1355.79V269ZM1377.84 269H1397.89V289H1377.84V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 246H1440V290H1397.89V246ZM1398.9 247H1439V267H1398.9V247ZM1397.89 269H1417.94V289H1397.89V269ZM1419.95 269H1440V289H1419.95V269Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 290H-117.895V334H-160V290ZM-158.997 291H-118.897V311H-158.997V291ZM-160 313H-139.95V333H-160V313ZM-137.945 313H-117.895V333H-137.945V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 290H-75.7895V334H-117.895V290ZM-116.892 291H-76.792V311H-116.892V291ZM-117.895 313H-97.8446V333H-117.895V313ZM-95.8396 313H-75.7895V333H-95.8396V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 290H218.947V334H176.842V290ZM177.845 291H217.945V311H177.845V291ZM176.842 313H196.892V333H176.842V313ZM198.897 313H218.947V333H198.897V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 290H261.053V334H218.947V290ZM219.95 291H260.05V311H219.95V291ZM218.947 313H238.997V333H218.947V313ZM241.003 313H261.053V333H241.003V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 290H555.789V334H513.684V290ZM514.687 291H554.787V311H514.687V291ZM513.684 313H533.734V333H513.684V313ZM535.739 313H555.789V333H535.739V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 290H597.895V334H555.789V290ZM556.792 291H596.892V311H556.792V291ZM555.789 313H575.84V333H555.789V313ZM577.845 313H597.895V333H577.845V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 290H976.842V334H934.737V290ZM935.739 291H975.84V311H935.739V291ZM934.737 313H954.787V333H934.737V313ZM956.792 313H976.842V333H956.792V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 290H1018.95V334H976.842V290ZM977.845 291H1017.94V311H977.845V291ZM976.842 313H996.892V333H976.842V313ZM998.897 313H1018.95V333H998.897V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 290H50.5263V334H8.42105V290ZM9.42355 291H49.5238V311H9.42355V291ZM8.42105 313H28.4712V333H8.42105V313ZM30.4762 313H50.5263V333H30.4762V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 290H92.6316V334H50.5263V290ZM51.5288 291H91.6291V311H51.5288V291ZM50.5263 313H70.5764V333H50.5263V313ZM72.5815 313H92.6316V333H72.5815V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 290H387.368V334H345.263V290ZM346.266 291H386.366V311H346.266V291ZM345.263 313H365.313V333H345.263V313ZM367.318 313H387.368V333H367.318V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 290H429.474V334H387.368V290ZM388.371 291H428.471V311H388.371V291ZM387.368 313H407.419V333H387.368V313ZM409.424 313H429.474V333H409.424V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 290H724.211V334H682.105V290ZM683.108 291H723.208V311H683.108V291ZM682.105 313H702.155V333H682.105V313ZM704.16 313H724.211V333H704.16V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 290H766.316V334H724.211V290ZM725.213 291H765.313V311H725.213V291ZM724.211 313H744.261V333H724.211V313ZM746.266 313H766.316V333H746.266V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 290H1145.26V334H1103.16V290ZM1104.16 291H1144.26V311H1104.16V291ZM1103.16 313H1123.21V333H1103.16V313ZM1125.21 313H1145.26V333H1125.21V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 290H1187.37V334H1145.26V290ZM1146.27 291H1186.37V311H1146.27V291ZM1145.26 313H1165.31V333H1145.26V313ZM1167.32 313H1187.37V333H1167.32V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 290H1313.68V334H1271.58V290ZM1272.58 291H1312.68V311H1272.58V291ZM1271.58 313H1291.63V333H1271.58V313ZM1293.63 313H1313.68V333H1293.63V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 290H1355.79V334H1313.68V290ZM1314.69 291H1354.79V311H1314.69V291ZM1313.68 313H1333.73V333H1313.68V313ZM1335.74 313H1355.79V333H1335.74V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 290H-33.6842V334H-75.7895V290ZM-74.787 291H-34.6867V311H-74.787V291ZM-75.7895 313H-55.7393V333H-75.7895V313ZM-53.7343 313H-33.6842V333H-53.7343V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 290H8.42105V334H-33.6842V290ZM-32.6817 291H7.41855V311H-32.6817V291ZM-33.6842 313H-13.6341V333H-33.6842V313ZM-11.6291 313H8.42105V333H-11.6291V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 290H303.158V334H261.053V290ZM262.055 291H302.155V311H262.055V291ZM261.053 313H281.103V333H261.053V313ZM283.108 313H303.158V333H283.108V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 290H345.263V334H303.158V290ZM304.16 291H344.261V311H304.16V291ZM303.158 313H323.208V333H303.158V313ZM325.213 313H345.263V333H325.213V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 290H640V334H597.895V290ZM598.897 291H638.997V311H598.897V291ZM597.895 313H617.945V333H597.895V313ZM619.95 313H640V333H619.95V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 290H682.105V334H640V290ZM641.003 291H681.103V311H641.003V291ZM640 313H660.05V333H640V313ZM662.055 313H682.105V333H662.055V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 290H1061.05V334H1018.95V290ZM1019.95 291H1060.05V311H1019.95V291ZM1018.95 313H1039V333H1018.95V313ZM1041 313H1061.05V333H1041V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 290H1103.16V334H1061.05V290ZM1062.06 291H1102.16V311H1062.06V291ZM1061.05 313H1081.1V333H1061.05V313ZM1083.11 313H1103.16V333H1083.11V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 290H134.737V334H92.6316V290ZM93.6341 291H133.734V311H93.6341V291ZM92.6316 313H112.682V333H92.6316V313ZM114.687 313H134.737V333H114.687V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 290H176.842V334H134.737V290ZM135.739 291H175.84V311H135.739V291ZM134.737 313H154.787V333H134.737V313ZM156.792 313H176.842V333H156.792V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 290H471.579V334H429.474V290ZM430.476 291H470.576V311H430.476V291ZM429.474 313H449.524V333H429.474V313ZM451.529 313H471.579V333H451.529V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 290H513.684V334H471.579V290ZM472.581 291H512.682V311H472.581V291ZM471.579 313H491.629V333H471.579V313ZM493.634 313H513.684V333H493.634V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 290H892.632V334H850.526V290ZM851.529 291H891.629V311H851.529V291ZM850.526 313H870.576V333H850.526V313ZM872.581 313H892.632V333H872.581V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 290H934.737V334H892.632V290ZM893.634 291H933.734V311H893.634V291ZM892.632 313H912.682V333H892.632V313ZM914.687 313H934.737V333H914.687V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 290H808.421V334H766.316V290ZM767.318 291H807.419V311H767.318V291ZM766.316 313H786.366V333H766.316V313ZM788.371 313H808.421V333H788.371V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 290H850.526V334H808.421V290ZM809.424 291H849.524V311H809.424V291ZM808.421 313H828.471V333H808.421V313ZM830.476 313H850.526V333H830.476V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 290H1229.47V334H1187.37V290ZM1188.37 291H1228.47V311H1188.37V291ZM1187.37 313H1207.42V333H1187.37V313ZM1209.42 313H1229.47V333H1209.42V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 290H1271.58V334H1229.47V290ZM1230.48 291H1270.58V311H1230.48V291ZM1229.47 313H1249.52V333H1229.47V313ZM1251.53 313H1271.58V333H1251.53V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 290H1397.89V334H1355.79V290ZM1356.79 291H1396.89V311H1356.79V291ZM1355.79 313H1375.84V333H1355.79V313ZM1377.84 313H1397.89V333H1377.84V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 290H1440V334H1397.89V290ZM1398.9 291H1439V311H1398.9V291ZM1397.89 313H1417.94V333H1397.89V313ZM1419.95 313H1440V333H1419.95V313Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 334H-117.895V378H-160V334ZM-158.997 335H-118.897V355H-158.997V335ZM-160 357H-139.95V377H-160V357ZM-137.945 357H-117.895V377H-137.945V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 334H-75.7895V378H-117.895V334ZM-116.892 335H-76.792V355H-116.892V335ZM-117.895 357H-97.8446V377H-117.895V357ZM-95.8396 357H-75.7895V377H-95.8396V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 334H218.947V378H176.842V334ZM177.845 335H217.945V355H177.845V335ZM176.842 357H196.892V377H176.842V357ZM198.897 357H218.947V377H198.897V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 334H261.053V378H218.947V334ZM219.95 335H260.05V355H219.95V335ZM218.947 357H238.997V377H218.947V357ZM241.003 357H261.053V377H241.003V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 334H555.789V378H513.684V334ZM514.687 335H554.787V355H514.687V335ZM513.684 357H533.734V377H513.684V357ZM535.739 357H555.789V377H535.739V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 334H597.895V378H555.789V334ZM556.792 335H596.892V355H556.792V335ZM555.789 357H575.84V377H555.789V357ZM577.845 357H597.895V377H577.845V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 334H976.842V378H934.737V334ZM935.739 335H975.84V355H935.739V335ZM934.737 357H954.787V377H934.737V357ZM956.792 357H976.842V377H956.792V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 334H1018.95V378H976.842V334ZM977.845 335H1017.94V355H977.845V335ZM976.842 357H996.892V377H976.842V357ZM998.897 357H1018.95V377H998.897V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 334H50.5263V378H8.42105V334ZM9.42355 335H49.5238V355H9.42355V335ZM8.42105 357H28.4712V377H8.42105V357ZM30.4762 357H50.5263V377H30.4762V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 334H92.6316V378H50.5263V334ZM51.5288 335H91.6291V355H51.5288V335ZM50.5263 357H70.5764V377H50.5263V357ZM72.5815 357H92.6316V377H72.5815V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 334H387.368V378H345.263V334ZM346.266 335H386.366V355H346.266V335ZM345.263 357H365.313V377H345.263V357ZM367.318 357H387.368V377H367.318V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 334H429.474V378H387.368V334ZM388.371 335H428.471V355H388.371V335ZM387.368 357H407.419V377H387.368V357ZM409.424 357H429.474V377H409.424V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 334H724.211V378H682.105V334ZM683.108 335H723.208V355H683.108V335ZM682.105 357H702.155V377H682.105V357ZM704.16 357H724.211V377H704.16V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 334H766.316V378H724.211V334ZM725.213 335H765.313V355H725.213V335ZM724.211 357H744.261V377H724.211V357ZM746.266 357H766.316V377H746.266V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 334H1145.26V378H1103.16V334ZM1104.16 335H1144.26V355H1104.16V335ZM1103.16 357H1123.21V377H1103.16V357ZM1125.21 357H1145.26V377H1125.21V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 334H1187.37V378H1145.26V334ZM1146.27 335H1186.37V355H1146.27V335ZM1145.26 357H1165.31V377H1145.26V357ZM1167.32 357H1187.37V377H1167.32V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 334H1313.68V378H1271.58V334ZM1272.58 335H1312.68V355H1272.58V335ZM1271.58 357H1291.63V377H1271.58V357ZM1293.63 357H1313.68V377H1293.63V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 334H1355.79V378H1313.68V334ZM1314.69 335H1354.79V355H1314.69V335ZM1313.68 357H1333.73V377H1313.68V357ZM1335.74 357H1355.79V377H1335.74V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 334H-33.6842V378H-75.7895V334ZM-74.787 335H-34.6867V355H-74.787V335ZM-75.7895 357H-55.7393V377H-75.7895V357ZM-53.7343 357H-33.6842V377H-53.7343V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 334H8.42105V378H-33.6842V334ZM-32.6817 335H7.41855V355H-32.6817V335ZM-33.6842 357H-13.6341V377H-33.6842V357ZM-11.6291 357H8.42105V377H-11.6291V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 334H303.158V378H261.053V334ZM262.055 335H302.155V355H262.055V335ZM261.053 357H281.103V377H261.053V357ZM283.108 357H303.158V377H283.108V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 334H345.263V378H303.158V334ZM304.16 335H344.261V355H304.16V335ZM303.158 357H323.208V377H303.158V357ZM325.213 357H345.263V377H325.213V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 334H640V378H597.895V334ZM598.897 335H638.997V355H598.897V335ZM597.895 357H617.945V377H597.895V357ZM619.95 357H640V377H619.95V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 334H682.105V378H640V334ZM641.003 335H681.103V355H641.003V335ZM640 357H660.05V377H640V357ZM662.055 357H682.105V377H662.055V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 334H1061.05V378H1018.95V334ZM1019.95 335H1060.05V355H1019.95V335ZM1018.95 357H1039V377H1018.95V357ZM1041 357H1061.05V377H1041V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 334H1103.16V378H1061.05V334ZM1062.06 335H1102.16V355H1062.06V335ZM1061.05 357H1081.1V377H1061.05V357ZM1083.11 357H1103.16V377H1083.11V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 334H134.737V378H92.6316V334ZM93.6341 335H133.734V355H93.6341V335ZM92.6316 357H112.682V377H92.6316V357ZM114.687 357H134.737V377H114.687V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 334H176.842V378H134.737V334ZM135.739 335H175.84V355H135.739V335ZM134.737 357H154.787V377H134.737V357ZM156.792 357H176.842V377H156.792V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 334H471.579V378H429.474V334ZM430.476 335H470.576V355H430.476V335ZM429.474 357H449.524V377H429.474V357ZM451.529 357H471.579V377H451.529V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 334H513.684V378H471.579V334ZM472.581 335H512.682V355H472.581V335ZM471.579 357H491.629V377H471.579V357ZM493.634 357H513.684V377H493.634V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 334H892.632V378H850.526V334ZM851.529 335H891.629V355H851.529V335ZM850.526 357H870.576V377H850.526V357ZM872.581 357H892.632V377H872.581V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 334H934.737V378H892.632V334ZM893.634 335H933.734V355H893.634V335ZM892.632 357H912.682V377H892.632V357ZM914.687 357H934.737V377H914.687V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 334H808.421V378H766.316V334ZM767.318 335H807.419V355H767.318V335ZM766.316 357H786.366V377H766.316V357ZM788.371 357H808.421V377H788.371V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 334H850.526V378H808.421V334ZM809.424 335H849.524V355H809.424V335ZM808.421 357H828.471V377H808.421V357ZM830.476 357H850.526V377H830.476V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 334H1229.47V378H1187.37V334ZM1188.37 335H1228.47V355H1188.37V335ZM1187.37 357H1207.42V377H1187.37V357ZM1209.42 357H1229.47V377H1209.42V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 334H1271.58V378H1229.47V334ZM1230.48 335H1270.58V355H1230.48V335ZM1229.47 357H1249.52V377H1229.47V357ZM1251.53 357H1271.58V377H1251.53V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 334H1397.89V378H1355.79V334ZM1356.79 335H1396.89V355H1356.79V335ZM1355.79 357H1375.84V377H1355.79V357ZM1377.84 357H1397.89V377H1377.84V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 334H1440V378H1397.89V334ZM1398.9 335H1439V355H1398.9V335ZM1397.89 357H1417.94V377H1397.89V357ZM1419.95 357H1440V377H1419.95V357Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 378H-117.895V422H-160V378ZM-158.997 379H-118.897V399H-158.997V379ZM-160 401H-139.95V421H-160V401ZM-137.945 401H-117.895V421H-137.945V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 378H-75.7895V422H-117.895V378ZM-116.892 379H-76.792V399H-116.892V379ZM-117.895 401H-97.8446V421H-117.895V401ZM-95.8396 401H-75.7895V421H-95.8396V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 378H218.947V422H176.842V378ZM177.845 379H217.945V399H177.845V379ZM176.842 401H196.892V421H176.842V401ZM198.897 401H218.947V421H198.897V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 378H261.053V422H218.947V378ZM219.95 379H260.05V399H219.95V379ZM218.947 401H238.997V421H218.947V401ZM241.003 401H261.053V421H241.003V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 378H555.789V422H513.684V378ZM514.687 379H554.787V399H514.687V379ZM513.684 401H533.734V421H513.684V401ZM535.739 401H555.789V421H535.739V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 378H597.895V422H555.789V378ZM556.792 379H596.892V399H556.792V379ZM555.789 401H575.84V421H555.789V401ZM577.845 401H597.895V421H577.845V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 378H976.842V422H934.737V378ZM935.739 379H975.84V399H935.739V379ZM934.737 401H954.787V421H934.737V401ZM956.792 401H976.842V421H956.792V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 378H1018.95V422H976.842V378ZM977.845 379H1017.94V399H977.845V379ZM976.842 401H996.892V421H976.842V401ZM998.897 401H1018.95V421H998.897V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 378H50.5263V422H8.42105V378ZM9.42355 379H49.5238V399H9.42355V379ZM8.42105 401H28.4712V421H8.42105V401ZM30.4762 401H50.5263V421H30.4762V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 378H92.6316V422H50.5263V378ZM51.5288 379H91.6291V399H51.5288V379ZM50.5263 401H70.5764V421H50.5263V401ZM72.5815 401H92.6316V421H72.5815V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 378H387.368V422H345.263V378ZM346.266 379H386.366V399H346.266V379ZM345.263 401H365.313V421H345.263V401ZM367.318 401H387.368V421H367.318V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 378H429.474V422H387.368V378ZM388.371 379H428.471V399H388.371V379ZM387.368 401H407.419V421H387.368V401ZM409.424 401H429.474V421H409.424V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 378H724.211V422H682.105V378ZM683.108 379H723.208V399H683.108V379ZM682.105 401H702.155V421H682.105V401ZM704.16 401H724.211V421H704.16V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 378H766.316V422H724.211V378ZM725.213 379H765.313V399H725.213V379ZM724.211 401H744.261V421H724.211V401ZM746.266 401H766.316V421H746.266V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 378H1145.26V422H1103.16V378ZM1104.16 379H1144.26V399H1104.16V379ZM1103.16 401H1123.21V421H1103.16V401ZM1125.21 401H1145.26V421H1125.21V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 378H1187.37V422H1145.26V378ZM1146.27 379H1186.37V399H1146.27V379ZM1145.26 401H1165.31V421H1145.26V401ZM1167.32 401H1187.37V421H1167.32V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 378H1313.68V422H1271.58V378ZM1272.58 379H1312.68V399H1272.58V379ZM1271.58 401H1291.63V421H1271.58V401ZM1293.63 401H1313.68V421H1293.63V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 378H1355.79V422H1313.68V378ZM1314.69 379H1354.79V399H1314.69V379ZM1313.68 401H1333.73V421H1313.68V401ZM1335.74 401H1355.79V421H1335.74V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 378H-33.6842V422H-75.7895V378ZM-74.787 379H-34.6867V399H-74.787V379ZM-75.7895 401H-55.7393V421H-75.7895V401ZM-53.7343 401H-33.6842V421H-53.7343V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 378H8.42105V422H-33.6842V378ZM-32.6817 379H7.41855V399H-32.6817V379ZM-33.6842 401H-13.6341V421H-33.6842V401ZM-11.6291 401H8.42105V421H-11.6291V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 378H303.158V422H261.053V378ZM262.055 379H302.155V399H262.055V379ZM261.053 401H281.103V421H261.053V401ZM283.108 401H303.158V421H283.108V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 378H345.263V422H303.158V378ZM304.16 379H344.261V399H304.16V379ZM303.158 401H323.208V421H303.158V401ZM325.213 401H345.263V421H325.213V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 378H640V422H597.895V378ZM598.897 379H638.997V399H598.897V379ZM597.895 401H617.945V421H597.895V401ZM619.95 401H640V421H619.95V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 378H682.105V422H640V378ZM641.003 379H681.103V399H641.003V379ZM640 401H660.05V421H640V401ZM662.055 401H682.105V421H662.055V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 378H1061.05V422H1018.95V378ZM1019.95 379H1060.05V399H1019.95V379ZM1018.95 401H1039V421H1018.95V401ZM1041 401H1061.05V421H1041V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 378H1103.16V422H1061.05V378ZM1062.06 379H1102.16V399H1062.06V379ZM1061.05 401H1081.1V421H1061.05V401ZM1083.11 401H1103.16V421H1083.11V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 378H134.737V422H92.6316V378ZM93.6341 379H133.734V399H93.6341V379ZM92.6316 401H112.682V421H92.6316V401ZM114.687 401H134.737V421H114.687V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 378H176.842V422H134.737V378ZM135.739 379H175.84V399H135.739V379ZM134.737 401H154.787V421H134.737V401ZM156.792 401H176.842V421H156.792V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 378H471.579V422H429.474V378ZM430.476 379H470.576V399H430.476V379ZM429.474 401H449.524V421H429.474V401ZM451.529 401H471.579V421H451.529V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 378H513.684V422H471.579V378ZM472.581 379H512.682V399H472.581V379ZM471.579 401H491.629V421H471.579V401ZM493.634 401H513.684V421H493.634V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 378H892.632V422H850.526V378ZM851.529 379H891.629V399H851.529V379ZM850.526 401H870.576V421H850.526V401ZM872.581 401H892.632V421H872.581V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 378H934.737V422H892.632V378ZM893.634 379H933.734V399H893.634V379ZM892.632 401H912.682V421H892.632V401ZM914.687 401H934.737V421H914.687V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 378H808.421V422H766.316V378ZM767.318 379H807.419V399H767.318V379ZM766.316 401H786.366V421H766.316V401ZM788.371 401H808.421V421H788.371V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 378H850.526V422H808.421V378ZM809.424 379H849.524V399H809.424V379ZM808.421 401H828.471V421H808.421V401ZM830.476 401H850.526V421H830.476V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 378H1229.47V422H1187.37V378ZM1188.37 379H1228.47V399H1188.37V379ZM1187.37 401H1207.42V421H1187.37V401ZM1209.42 401H1229.47V421H1209.42V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 378H1271.58V422H1229.47V378ZM1230.48 379H1270.58V399H1230.48V379ZM1229.47 401H1249.52V421H1229.47V401ZM1251.53 401H1271.58V421H1251.53V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 378H1397.89V422H1355.79V378ZM1356.79 379H1396.89V399H1356.79V379ZM1355.79 401H1375.84V421H1355.79V401ZM1377.84 401H1397.89V421H1377.84V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 378H1440V422H1397.89V378ZM1398.9 379H1439V399H1398.9V379ZM1397.89 401H1417.94V421H1397.89V401ZM1419.95 401H1440V421H1419.95V401Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 422H-117.895V466H-160V422ZM-158.997 423H-118.897V443H-158.997V423ZM-160 445H-139.95V465H-160V445ZM-137.945 445H-117.895V465H-137.945V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 422H-75.7895V466H-117.895V422ZM-116.892 423H-76.792V443H-116.892V423ZM-117.895 445H-97.8446V465H-117.895V445ZM-95.8396 445H-75.7895V465H-95.8396V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 422H218.947V466H176.842V422ZM177.845 423H217.945V443H177.845V423ZM176.842 445H196.892V465H176.842V445ZM198.897 445H218.947V465H198.897V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 422H261.053V466H218.947V422ZM219.95 423H260.05V443H219.95V423ZM218.947 445H238.997V465H218.947V445ZM241.003 445H261.053V465H241.003V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 422H555.789V466H513.684V422ZM514.687 423H554.787V443H514.687V423ZM513.684 445H533.734V465H513.684V445ZM535.739 445H555.789V465H535.739V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 422H597.895V466H555.789V422ZM556.792 423H596.892V443H556.792V423ZM555.789 445H575.84V465H555.789V445ZM577.845 445H597.895V465H577.845V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 422H976.842V466H934.737V422ZM935.739 423H975.84V443H935.739V423ZM934.737 445H954.787V465H934.737V445ZM956.792 445H976.842V465H956.792V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 422H1018.95V466H976.842V422ZM977.845 423H1017.94V443H977.845V423ZM976.842 445H996.892V465H976.842V445ZM998.897 445H1018.95V465H998.897V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 422H50.5263V466H8.42105V422ZM9.42355 423H49.5238V443H9.42355V423ZM8.42105 445H28.4712V465H8.42105V445ZM30.4762 445H50.5263V465H30.4762V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 422H92.6316V466H50.5263V422ZM51.5288 423H91.6291V443H51.5288V423ZM50.5263 445H70.5764V465H50.5263V445ZM72.5815 445H92.6316V465H72.5815V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 422H387.368V466H345.263V422ZM346.266 423H386.366V443H346.266V423ZM345.263 445H365.313V465H345.263V445ZM367.318 445H387.368V465H367.318V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 422H429.474V466H387.368V422ZM388.371 423H428.471V443H388.371V423ZM387.368 445H407.419V465H387.368V445ZM409.424 445H429.474V465H409.424V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 422H724.211V466H682.105V422ZM683.108 423H723.208V443H683.108V423ZM682.105 445H702.155V465H682.105V445ZM704.16 445H724.211V465H704.16V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 422H766.316V466H724.211V422ZM725.213 423H765.313V443H725.213V423ZM724.211 445H744.261V465H724.211V445ZM746.266 445H766.316V465H746.266V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 422H1145.26V466H1103.16V422ZM1104.16 423H1144.26V443H1104.16V423ZM1103.16 445H1123.21V465H1103.16V445ZM1125.21 445H1145.26V465H1125.21V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 422H1187.37V466H1145.26V422ZM1146.27 423H1186.37V443H1146.27V423ZM1145.26 445H1165.31V465H1145.26V445ZM1167.32 445H1187.37V465H1167.32V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 422H1313.68V466H1271.58V422ZM1272.58 423H1312.68V443H1272.58V423ZM1271.58 445H1291.63V465H1271.58V445ZM1293.63 445H1313.68V465H1293.63V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 422H1355.79V466H1313.68V422ZM1314.69 423H1354.79V443H1314.69V423ZM1313.68 445H1333.73V465H1313.68V445ZM1335.74 445H1355.79V465H1335.74V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 422H-33.6842V466H-75.7895V422ZM-74.787 423H-34.6867V443H-74.787V423ZM-75.7895 445H-55.7393V465H-75.7895V445ZM-53.7343 445H-33.6842V465H-53.7343V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 422H8.42105V466H-33.6842V422ZM-32.6817 423H7.41855V443H-32.6817V423ZM-33.6842 445H-13.6341V465H-33.6842V445ZM-11.6291 445H8.42105V465H-11.6291V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 422H303.158V466H261.053V422ZM262.055 423H302.155V443H262.055V423ZM261.053 445H281.103V465H261.053V445ZM283.108 445H303.158V465H283.108V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 422H345.263V466H303.158V422ZM304.16 423H344.261V443H304.16V423ZM303.158 445H323.208V465H303.158V445ZM325.213 445H345.263V465H325.213V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 422H640V466H597.895V422ZM598.897 423H638.997V443H598.897V423ZM597.895 445H617.945V465H597.895V445ZM619.95 445H640V465H619.95V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 422H682.105V466H640V422ZM641.003 423H681.103V443H641.003V423ZM640 445H660.05V465H640V445ZM662.055 445H682.105V465H662.055V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 422H1061.05V466H1018.95V422ZM1019.95 423H1060.05V443H1019.95V423ZM1018.95 445H1039V465H1018.95V445ZM1041 445H1061.05V465H1041V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 422H1103.16V466H1061.05V422ZM1062.06 423H1102.16V443H1062.06V423ZM1061.05 445H1081.1V465H1061.05V445ZM1083.11 445H1103.16V465H1083.11V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 422H134.737V466H92.6316V422ZM93.6341 423H133.734V443H93.6341V423ZM92.6316 445H112.682V465H92.6316V445ZM114.687 445H134.737V465H114.687V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 422H176.842V466H134.737V422ZM135.739 423H175.84V443H135.739V423ZM134.737 445H154.787V465H134.737V445ZM156.792 445H176.842V465H156.792V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 422H471.579V466H429.474V422ZM430.476 423H470.576V443H430.476V423ZM429.474 445H449.524V465H429.474V445ZM451.529 445H471.579V465H451.529V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 422H513.684V466H471.579V422ZM472.581 423H512.682V443H472.581V423ZM471.579 445H491.629V465H471.579V445ZM493.634 445H513.684V465H493.634V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 422H892.632V466H850.526V422ZM851.529 423H891.629V443H851.529V423ZM850.526 445H870.576V465H850.526V445ZM872.581 445H892.632V465H872.581V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 422H934.737V466H892.632V422ZM893.634 423H933.734V443H893.634V423ZM892.632 445H912.682V465H892.632V445ZM914.687 445H934.737V465H914.687V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 422H808.421V466H766.316V422ZM767.318 423H807.419V443H767.318V423ZM766.316 445H786.366V465H766.316V445ZM788.371 445H808.421V465H788.371V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 422H850.526V466H808.421V422ZM809.424 423H849.524V443H809.424V423ZM808.421 445H828.471V465H808.421V445ZM830.476 445H850.526V465H830.476V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 422H1229.47V466H1187.37V422ZM1188.37 423H1228.47V443H1188.37V423ZM1187.37 445H1207.42V465H1187.37V445ZM1209.42 445H1229.47V465H1209.42V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 422H1271.58V466H1229.47V422ZM1230.48 423H1270.58V443H1230.48V423ZM1229.47 445H1249.52V465H1229.47V445ZM1251.53 445H1271.58V465H1251.53V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 422H1397.89V466H1355.79V422ZM1356.79 423H1396.89V443H1356.79V423ZM1355.79 445H1375.84V465H1355.79V445ZM1377.84 445H1397.89V465H1377.84V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 422H1440V466H1397.89V422ZM1398.9 423H1439V443H1398.9V423ZM1397.89 445H1417.94V465H1397.89V445ZM1419.95 445H1440V465H1419.95V445Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 466H-117.895V510H-160V466ZM-158.997 467H-118.897V487H-158.997V467ZM-160 489H-139.95V509H-160V489ZM-137.945 489H-117.895V509H-137.945V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 466H-75.7895V510H-117.895V466ZM-116.892 467H-76.792V487H-116.892V467ZM-117.895 489H-97.8446V509H-117.895V489ZM-95.8396 489H-75.7895V509H-95.8396V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 466H218.947V510H176.842V466ZM177.845 467H217.945V487H177.845V467ZM176.842 489H196.892V509H176.842V489ZM198.897 489H218.947V509H198.897V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 466H261.053V510H218.947V466ZM219.95 467H260.05V487H219.95V467ZM218.947 489H238.997V509H218.947V489ZM241.003 489H261.053V509H241.003V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 466H555.789V510H513.684V466ZM514.687 467H554.787V487H514.687V467ZM513.684 489H533.734V509H513.684V489ZM535.739 489H555.789V509H535.739V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 466H597.895V510H555.789V466ZM556.792 467H596.892V487H556.792V467ZM555.789 489H575.84V509H555.789V489ZM577.845 489H597.895V509H577.845V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 466H976.842V510H934.737V466ZM935.739 467H975.84V487H935.739V467ZM934.737 489H954.787V509H934.737V489ZM956.792 489H976.842V509H956.792V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 466H1018.95V510H976.842V466ZM977.845 467H1017.94V487H977.845V467ZM976.842 489H996.892V509H976.842V489ZM998.897 489H1018.95V509H998.897V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 466H50.5263V510H8.42105V466ZM9.42355 467H49.5238V487H9.42355V467ZM8.42105 489H28.4712V509H8.42105V489ZM30.4762 489H50.5263V509H30.4762V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 466H92.6316V510H50.5263V466ZM51.5288 467H91.6291V487H51.5288V467ZM50.5263 489H70.5764V509H50.5263V489ZM72.5815 489H92.6316V509H72.5815V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 466H387.368V510H345.263V466ZM346.266 467H386.366V487H346.266V467ZM345.263 489H365.313V509H345.263V489ZM367.318 489H387.368V509H367.318V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 466H429.474V510H387.368V466ZM388.371 467H428.471V487H388.371V467ZM387.368 489H407.419V509H387.368V489ZM409.424 489H429.474V509H409.424V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 466H724.211V510H682.105V466ZM683.108 467H723.208V487H683.108V467ZM682.105 489H702.155V509H682.105V489ZM704.16 489H724.211V509H704.16V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 466H766.316V510H724.211V466ZM725.213 467H765.313V487H725.213V467ZM724.211 489H744.261V509H724.211V489ZM746.266 489H766.316V509H746.266V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 466H1145.26V510H1103.16V466ZM1104.16 467H1144.26V487H1104.16V467ZM1103.16 489H1123.21V509H1103.16V489ZM1125.21 489H1145.26V509H1125.21V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 466H1187.37V510H1145.26V466ZM1146.27 467H1186.37V487H1146.27V467ZM1145.26 489H1165.31V509H1145.26V489ZM1167.32 489H1187.37V509H1167.32V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 466H1313.68V510H1271.58V466ZM1272.58 467H1312.68V487H1272.58V467ZM1271.58 489H1291.63V509H1271.58V489ZM1293.63 489H1313.68V509H1293.63V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 466H1355.79V510H1313.68V466ZM1314.69 467H1354.79V487H1314.69V467ZM1313.68 489H1333.73V509H1313.68V489ZM1335.74 489H1355.79V509H1335.74V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 466H-33.6842V510H-75.7895V466ZM-74.787 467H-34.6867V487H-74.787V467ZM-75.7895 489H-55.7393V509H-75.7895V489ZM-53.7343 489H-33.6842V509H-53.7343V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 466H8.42105V510H-33.6842V466ZM-32.6817 467H7.41855V487H-32.6817V467ZM-33.6842 489H-13.6341V509H-33.6842V489ZM-11.6291 489H8.42105V509H-11.6291V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 466H303.158V510H261.053V466ZM262.055 467H302.155V487H262.055V467ZM261.053 489H281.103V509H261.053V489ZM283.108 489H303.158V509H283.108V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 466H345.263V510H303.158V466ZM304.16 467H344.261V487H304.16V467ZM303.158 489H323.208V509H303.158V489ZM325.213 489H345.263V509H325.213V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 466H640V510H597.895V466ZM598.897 467H638.997V487H598.897V467ZM597.895 489H617.945V509H597.895V489ZM619.95 489H640V509H619.95V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 466H682.105V510H640V466ZM641.003 467H681.103V487H641.003V467ZM640 489H660.05V509H640V489ZM662.055 489H682.105V509H662.055V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 466H1061.05V510H1018.95V466ZM1019.95 467H1060.05V487H1019.95V467ZM1018.95 489H1039V509H1018.95V489ZM1041 489H1061.05V509H1041V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 466H1103.16V510H1061.05V466ZM1062.06 467H1102.16V487H1062.06V467ZM1061.05 489H1081.1V509H1061.05V489ZM1083.11 489H1103.16V509H1083.11V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 466H134.737V510H92.6316V466ZM93.6341 467H133.734V487H93.6341V467ZM92.6316 489H112.682V509H92.6316V489ZM114.687 489H134.737V509H114.687V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 466H176.842V510H134.737V466ZM135.739 467H175.84V487H135.739V467ZM134.737 489H154.787V509H134.737V489ZM156.792 489H176.842V509H156.792V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 466H471.579V510H429.474V466ZM430.476 467H470.576V487H430.476V467ZM429.474 489H449.524V509H429.474V489ZM451.529 489H471.579V509H451.529V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 466H513.684V510H471.579V466ZM472.581 467H512.682V487H472.581V467ZM471.579 489H491.629V509H471.579V489ZM493.634 489H513.684V509H493.634V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 466H892.632V510H850.526V466ZM851.529 467H891.629V487H851.529V467ZM850.526 489H870.576V509H850.526V489ZM872.581 489H892.632V509H872.581V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 466H934.737V510H892.632V466ZM893.634 467H933.734V487H893.634V467ZM892.632 489H912.682V509H892.632V489ZM914.687 489H934.737V509H914.687V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 466H808.421V510H766.316V466ZM767.318 467H807.419V487H767.318V467ZM766.316 489H786.366V509H766.316V489ZM788.371 489H808.421V509H788.371V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 466H850.526V510H808.421V466ZM809.424 467H849.524V487H809.424V467ZM808.421 489H828.471V509H808.421V489ZM830.476 489H850.526V509H830.476V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 466H1229.47V510H1187.37V466ZM1188.37 467H1228.47V487H1188.37V467ZM1187.37 489H1207.42V509H1187.37V489ZM1209.42 489H1229.47V509H1209.42V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 466H1271.58V510H1229.47V466ZM1230.48 467H1270.58V487H1230.48V467ZM1229.47 489H1249.52V509H1229.47V489ZM1251.53 489H1271.58V509H1251.53V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 466H1397.89V510H1355.79V466ZM1356.79 467H1396.89V487H1356.79V467ZM1355.79 489H1375.84V509H1355.79V489ZM1377.84 489H1397.89V509H1377.84V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 466H1440V510H1397.89V466ZM1398.9 467H1439V487H1398.9V467ZM1397.89 489H1417.94V509H1397.89V489ZM1419.95 489H1440V509H1419.95V489Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 510H-117.895V554H-160V510ZM-158.997 511H-118.897V531H-158.997V511ZM-160 533H-139.95V553H-160V533ZM-137.945 533H-117.895V553H-137.945V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 510H-75.7895V554H-117.895V510ZM-116.892 511H-76.792V531H-116.892V511ZM-117.895 533H-97.8446V553H-117.895V533ZM-95.8396 533H-75.7895V553H-95.8396V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 510H218.947V554H176.842V510ZM177.845 511H217.945V531H177.845V511ZM176.842 533H196.892V553H176.842V533ZM198.897 533H218.947V553H198.897V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 510H261.053V554H218.947V510ZM219.95 511H260.05V531H219.95V511ZM218.947 533H238.997V553H218.947V533ZM241.003 533H261.053V553H241.003V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 510H555.789V554H513.684V510ZM514.687 511H554.787V531H514.687V511ZM513.684 533H533.734V553H513.684V533ZM535.739 533H555.789V553H535.739V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 510H597.895V554H555.789V510ZM556.792 511H596.892V531H556.792V511ZM555.789 533H575.84V553H555.789V533ZM577.845 533H597.895V553H577.845V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 510H976.842V554H934.737V510ZM935.739 511H975.84V531H935.739V511ZM934.737 533H954.787V553H934.737V533ZM956.792 533H976.842V553H956.792V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 510H1018.95V554H976.842V510ZM977.845 511H1017.94V531H977.845V511ZM976.842 533H996.892V553H976.842V533ZM998.897 533H1018.95V553H998.897V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 510H50.5263V554H8.42105V510ZM9.42355 511H49.5238V531H9.42355V511ZM8.42105 533H28.4712V553H8.42105V533ZM30.4762 533H50.5263V553H30.4762V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 510H92.6316V554H50.5263V510ZM51.5288 511H91.6291V531H51.5288V511ZM50.5263 533H70.5764V553H50.5263V533ZM72.5815 533H92.6316V553H72.5815V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 510H387.368V554H345.263V510ZM346.266 511H386.366V531H346.266V511ZM345.263 533H365.313V553H345.263V533ZM367.318 533H387.368V553H367.318V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 510H429.474V554H387.368V510ZM388.371 511H428.471V531H388.371V511ZM387.368 533H407.419V553H387.368V533ZM409.424 533H429.474V553H409.424V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 510H724.211V554H682.105V510ZM683.108 511H723.208V531H683.108V511ZM682.105 533H702.155V553H682.105V533ZM704.16 533H724.211V553H704.16V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 510H766.316V554H724.211V510ZM725.213 511H765.313V531H725.213V511ZM724.211 533H744.261V553H724.211V533ZM746.266 533H766.316V553H746.266V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 510H1145.26V554H1103.16V510ZM1104.16 511H1144.26V531H1104.16V511ZM1103.16 533H1123.21V553H1103.16V533ZM1125.21 533H1145.26V553H1125.21V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 510H1187.37V554H1145.26V510ZM1146.27 511H1186.37V531H1146.27V511ZM1145.26 533H1165.31V553H1145.26V533ZM1167.32 533H1187.37V553H1167.32V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 510H1313.68V554H1271.58V510ZM1272.58 511H1312.68V531H1272.58V511ZM1271.58 533H1291.63V553H1271.58V533ZM1293.63 533H1313.68V553H1293.63V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 510H1355.79V554H1313.68V510ZM1314.69 511H1354.79V531H1314.69V511ZM1313.68 533H1333.73V553H1313.68V533ZM1335.74 533H1355.79V553H1335.74V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 510H-33.6842V554H-75.7895V510ZM-74.787 511H-34.6867V531H-74.787V511ZM-75.7895 533H-55.7393V553H-75.7895V533ZM-53.7343 533H-33.6842V553H-53.7343V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 510H8.42105V554H-33.6842V510ZM-32.6817 511H7.41855V531H-32.6817V511ZM-33.6842 533H-13.6341V553H-33.6842V533ZM-11.6291 533H8.42105V553H-11.6291V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 510H303.158V554H261.053V510ZM262.055 511H302.155V531H262.055V511ZM261.053 533H281.103V553H261.053V533ZM283.108 533H303.158V553H283.108V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 510H345.263V554H303.158V510ZM304.16 511H344.261V531H304.16V511ZM303.158 533H323.208V553H303.158V533ZM325.213 533H345.263V553H325.213V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 510H640V554H597.895V510ZM598.897 511H638.997V531H598.897V511ZM597.895 533H617.945V553H597.895V533ZM619.95 533H640V553H619.95V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 510H682.105V554H640V510ZM641.003 511H681.103V531H641.003V511ZM640 533H660.05V553H640V533ZM662.055 533H682.105V553H662.055V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 510H1061.05V554H1018.95V510ZM1019.95 511H1060.05V531H1019.95V511ZM1018.95 533H1039V553H1018.95V533ZM1041 533H1061.05V553H1041V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 510H1103.16V554H1061.05V510ZM1062.06 511H1102.16V531H1062.06V511ZM1061.05 533H1081.1V553H1061.05V533ZM1083.11 533H1103.16V553H1083.11V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 510H134.737V554H92.6316V510ZM93.6341 511H133.734V531H93.6341V511ZM92.6316 533H112.682V553H92.6316V533ZM114.687 533H134.737V553H114.687V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 510H176.842V554H134.737V510ZM135.739 511H175.84V531H135.739V511ZM134.737 533H154.787V553H134.737V533ZM156.792 533H176.842V553H156.792V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 510H471.579V554H429.474V510ZM430.476 511H470.576V531H430.476V511ZM429.474 533H449.524V553H429.474V533ZM451.529 533H471.579V553H451.529V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 510H513.684V554H471.579V510ZM472.581 511H512.682V531H472.581V511ZM471.579 533H491.629V553H471.579V533ZM493.634 533H513.684V553H493.634V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 510H892.632V554H850.526V510ZM851.529 511H891.629V531H851.529V511ZM850.526 533H870.576V553H850.526V533ZM872.581 533H892.632V553H872.581V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 510H934.737V554H892.632V510ZM893.634 511H933.734V531H893.634V511ZM892.632 533H912.682V553H892.632V533ZM914.687 533H934.737V553H914.687V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 510H808.421V554H766.316V510ZM767.318 511H807.419V531H767.318V511ZM766.316 533H786.366V553H766.316V533ZM788.371 533H808.421V553H788.371V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 510H850.526V554H808.421V510ZM809.424 511H849.524V531H809.424V511ZM808.421 533H828.471V553H808.421V533ZM830.476 533H850.526V553H830.476V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 510H1229.47V554H1187.37V510ZM1188.37 511H1228.47V531H1188.37V511ZM1187.37 533H1207.42V553H1187.37V533ZM1209.42 533H1229.47V553H1209.42V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 510H1271.58V554H1229.47V510ZM1230.48 511H1270.58V531H1230.48V511ZM1229.47 533H1249.52V553H1229.47V533ZM1251.53 533H1271.58V553H1251.53V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 510H1397.89V554H1355.79V510ZM1356.79 511H1396.89V531H1356.79V511ZM1355.79 533H1375.84V553H1355.79V533ZM1377.84 533H1397.89V553H1377.84V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 510H1440V554H1397.89V510ZM1398.9 511H1439V531H1398.9V511ZM1397.89 533H1417.94V553H1397.89V533ZM1419.95 533H1440V553H1419.95V533Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 554H-117.895V598H-160V554ZM-158.997 555H-118.897V575H-158.997V555ZM-160 577H-139.95V597H-160V577ZM-137.945 577H-117.895V597H-137.945V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 554H-75.7895V598H-117.895V554ZM-116.892 555H-76.792V575H-116.892V555ZM-117.895 577H-97.8446V597H-117.895V577ZM-95.8396 577H-75.7895V597H-95.8396V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 554H218.947V598H176.842V554ZM177.845 555H217.945V575H177.845V555ZM176.842 577H196.892V597H176.842V577ZM198.897 577H218.947V597H198.897V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 554H261.053V598H218.947V554ZM219.95 555H260.05V575H219.95V555ZM218.947 577H238.997V597H218.947V577ZM241.003 577H261.053V597H241.003V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 554H555.789V598H513.684V554ZM514.687 555H554.787V575H514.687V555ZM513.684 577H533.734V597H513.684V577ZM535.739 577H555.789V597H535.739V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 554H597.895V598H555.789V554ZM556.792 555H596.892V575H556.792V555ZM555.789 577H575.84V597H555.789V577ZM577.845 577H597.895V597H577.845V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 554H976.842V598H934.737V554ZM935.739 555H975.84V575H935.739V555ZM934.737 577H954.787V597H934.737V577ZM956.792 577H976.842V597H956.792V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 554H1018.95V598H976.842V554ZM977.845 555H1017.94V575H977.845V555ZM976.842 577H996.892V597H976.842V577ZM998.897 577H1018.95V597H998.897V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 554H50.5263V598H8.42105V554ZM9.42355 555H49.5238V575H9.42355V555ZM8.42105 577H28.4712V597H8.42105V577ZM30.4762 577H50.5263V597H30.4762V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 554H92.6316V598H50.5263V554ZM51.5288 555H91.6291V575H51.5288V555ZM50.5263 577H70.5764V597H50.5263V577ZM72.5815 577H92.6316V597H72.5815V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 554H387.368V598H345.263V554ZM346.266 555H386.366V575H346.266V555ZM345.263 577H365.313V597H345.263V577ZM367.318 577H387.368V597H367.318V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 554H429.474V598H387.368V554ZM388.371 555H428.471V575H388.371V555ZM387.368 577H407.419V597H387.368V577ZM409.424 577H429.474V597H409.424V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 554H724.211V598H682.105V554ZM683.108 555H723.208V575H683.108V555ZM682.105 577H702.155V597H682.105V577ZM704.16 577H724.211V597H704.16V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 554H766.316V598H724.211V554ZM725.213 555H765.313V575H725.213V555ZM724.211 577H744.261V597H724.211V577ZM746.266 577H766.316V597H746.266V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 554H1145.26V598H1103.16V554ZM1104.16 555H1144.26V575H1104.16V555ZM1103.16 577H1123.21V597H1103.16V577ZM1125.21 577H1145.26V597H1125.21V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 554H1187.37V598H1145.26V554ZM1146.27 555H1186.37V575H1146.27V555ZM1145.26 577H1165.31V597H1145.26V577ZM1167.32 577H1187.37V597H1167.32V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 554H1313.68V598H1271.58V554ZM1272.58 555H1312.68V575H1272.58V555ZM1271.58 577H1291.63V597H1271.58V577ZM1293.63 577H1313.68V597H1293.63V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 554H1355.79V598H1313.68V554ZM1314.69 555H1354.79V575H1314.69V555ZM1313.68 577H1333.73V597H1313.68V577ZM1335.74 577H1355.79V597H1335.74V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 554H-33.6842V598H-75.7895V554ZM-74.787 555H-34.6867V575H-74.787V555ZM-75.7895 577H-55.7393V597H-75.7895V577ZM-53.7343 577H-33.6842V597H-53.7343V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 554H8.42105V598H-33.6842V554ZM-32.6817 555H7.41855V575H-32.6817V555ZM-33.6842 577H-13.6341V597H-33.6842V577ZM-11.6291 577H8.42105V597H-11.6291V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 554H303.158V598H261.053V554ZM262.055 555H302.155V575H262.055V555ZM261.053 577H281.103V597H261.053V577ZM283.108 577H303.158V597H283.108V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 554H345.263V598H303.158V554ZM304.16 555H344.261V575H304.16V555ZM303.158 577H323.208V597H303.158V577ZM325.213 577H345.263V597H325.213V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 554H640V598H597.895V554ZM598.897 555H638.997V575H598.897V555ZM597.895 577H617.945V597H597.895V577ZM619.95 577H640V597H619.95V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 554H682.105V598H640V554ZM641.003 555H681.103V575H641.003V555ZM640 577H660.05V597H640V577ZM662.055 577H682.105V597H662.055V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 554H1061.05V598H1018.95V554ZM1019.95 555H1060.05V575H1019.95V555ZM1018.95 577H1039V597H1018.95V577ZM1041 577H1061.05V597H1041V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 554H1103.16V598H1061.05V554ZM1062.06 555H1102.16V575H1062.06V555ZM1061.05 577H1081.1V597H1061.05V577ZM1083.11 577H1103.16V597H1083.11V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 554H134.737V598H92.6316V554ZM93.6341 555H133.734V575H93.6341V555ZM92.6316 577H112.682V597H92.6316V577ZM114.687 577H134.737V597H114.687V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 554H176.842V598H134.737V554ZM135.739 555H175.84V575H135.739V555ZM134.737 577H154.787V597H134.737V577ZM156.792 577H176.842V597H156.792V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 554H471.579V598H429.474V554ZM430.476 555H470.576V575H430.476V555ZM429.474 577H449.524V597H429.474V577ZM451.529 577H471.579V597H451.529V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 554H513.684V598H471.579V554ZM472.581 555H512.682V575H472.581V555ZM471.579 577H491.629V597H471.579V577ZM493.634 577H513.684V597H493.634V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 554H892.632V598H850.526V554ZM851.529 555H891.629V575H851.529V555ZM850.526 577H870.576V597H850.526V577ZM872.581 577H892.632V597H872.581V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 554H934.737V598H892.632V554ZM893.634 555H933.734V575H893.634V555ZM892.632 577H912.682V597H892.632V577ZM914.687 577H934.737V597H914.687V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 554H808.421V598H766.316V554ZM767.318 555H807.419V575H767.318V555ZM766.316 577H786.366V597H766.316V577ZM788.371 577H808.421V597H788.371V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 554H850.526V598H808.421V554ZM809.424 555H849.524V575H809.424V555ZM808.421 577H828.471V597H808.421V577ZM830.476 577H850.526V597H830.476V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 554H1229.47V598H1187.37V554ZM1188.37 555H1228.47V575H1188.37V555ZM1187.37 577H1207.42V597H1187.37V577ZM1209.42 577H1229.47V597H1209.42V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 554H1271.58V598H1229.47V554ZM1230.48 555H1270.58V575H1230.48V555ZM1229.47 577H1249.52V597H1229.47V577ZM1251.53 577H1271.58V597H1251.53V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 554H1397.89V598H1355.79V554ZM1356.79 555H1396.89V575H1356.79V555ZM1355.79 577H1375.84V597H1355.79V577ZM1377.84 577H1397.89V597H1377.84V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 554H1440V598H1397.89V554ZM1398.9 555H1439V575H1398.9V555ZM1397.89 577H1417.94V597H1397.89V577ZM1419.95 577H1440V597H1419.95V577Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 598H-117.895V642H-160V598ZM-158.997 599H-118.897V619H-158.997V599ZM-160 621H-139.95V641H-160V621ZM-137.945 621H-117.895V641H-137.945V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 598H-75.7895V642H-117.895V598ZM-116.892 599H-76.792V619H-116.892V599ZM-117.895 621H-97.8446V641H-117.895V621ZM-95.8396 621H-75.7895V641H-95.8396V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 598H218.947V642H176.842V598ZM177.845 599H217.945V619H177.845V599ZM176.842 621H196.892V641H176.842V621ZM198.897 621H218.947V641H198.897V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 598H261.053V642H218.947V598ZM219.95 599H260.05V619H219.95V599ZM218.947 621H238.997V641H218.947V621ZM241.003 621H261.053V641H241.003V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 598H555.789V642H513.684V598ZM514.687 599H554.787V619H514.687V599ZM513.684 621H533.734V641H513.684V621ZM535.739 621H555.789V641H535.739V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 598H597.895V642H555.789V598ZM556.792 599H596.892V619H556.792V599ZM555.789 621H575.84V641H555.789V621ZM577.845 621H597.895V641H577.845V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 598H976.842V642H934.737V598ZM935.739 599H975.84V619H935.739V599ZM934.737 621H954.787V641H934.737V621ZM956.792 621H976.842V641H956.792V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 598H1018.95V642H976.842V598ZM977.845 599H1017.94V619H977.845V599ZM976.842 621H996.892V641H976.842V621ZM998.897 621H1018.95V641H998.897V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 598H50.5263V642H8.42105V598ZM9.42355 599H49.5238V619H9.42355V599ZM8.42105 621H28.4712V641H8.42105V621ZM30.4762 621H50.5263V641H30.4762V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 598H92.6316V642H50.5263V598ZM51.5288 599H91.6291V619H51.5288V599ZM50.5263 621H70.5764V641H50.5263V621ZM72.5815 621H92.6316V641H72.5815V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 598H387.368V642H345.263V598ZM346.266 599H386.366V619H346.266V599ZM345.263 621H365.313V641H345.263V621ZM367.318 621H387.368V641H367.318V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 598H429.474V642H387.368V598ZM388.371 599H428.471V619H388.371V599ZM387.368 621H407.419V641H387.368V621ZM409.424 621H429.474V641H409.424V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 598H724.211V642H682.105V598ZM683.108 599H723.208V619H683.108V599ZM682.105 621H702.155V641H682.105V621ZM704.16 621H724.211V641H704.16V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 598H766.316V642H724.211V598ZM725.213 599H765.313V619H725.213V599ZM724.211 621H744.261V641H724.211V621ZM746.266 621H766.316V641H746.266V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 598H1145.26V642H1103.16V598ZM1104.16 599H1144.26V619H1104.16V599ZM1103.16 621H1123.21V641H1103.16V621ZM1125.21 621H1145.26V641H1125.21V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 598H1187.37V642H1145.26V598ZM1146.27 599H1186.37V619H1146.27V599ZM1145.26 621H1165.31V641H1145.26V621ZM1167.32 621H1187.37V641H1167.32V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 598H1313.68V642H1271.58V598ZM1272.58 599H1312.68V619H1272.58V599ZM1271.58 621H1291.63V641H1271.58V621ZM1293.63 621H1313.68V641H1293.63V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 598H1355.79V642H1313.68V598ZM1314.69 599H1354.79V619H1314.69V599ZM1313.68 621H1333.73V641H1313.68V621ZM1335.74 621H1355.79V641H1335.74V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 598H-33.6842V642H-75.7895V598ZM-74.787 599H-34.6867V619H-74.787V599ZM-75.7895 621H-55.7393V641H-75.7895V621ZM-53.7343 621H-33.6842V641H-53.7343V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 598H8.42105V642H-33.6842V598ZM-32.6817 599H7.41855V619H-32.6817V599ZM-33.6842 621H-13.6341V641H-33.6842V621ZM-11.6291 621H8.42105V641H-11.6291V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 598H303.158V642H261.053V598ZM262.055 599H302.155V619H262.055V599ZM261.053 621H281.103V641H261.053V621ZM283.108 621H303.158V641H283.108V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 598H345.263V642H303.158V598ZM304.16 599H344.261V619H304.16V599ZM303.158 621H323.208V641H303.158V621ZM325.213 621H345.263V641H325.213V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 598H640V642H597.895V598ZM598.897 599H638.997V619H598.897V599ZM597.895 621H617.945V641H597.895V621ZM619.95 621H640V641H619.95V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 598H682.105V642H640V598ZM641.003 599H681.103V619H641.003V599ZM640 621H660.05V641H640V621ZM662.055 621H682.105V641H662.055V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 598H1061.05V642H1018.95V598ZM1019.95 599H1060.05V619H1019.95V599ZM1018.95 621H1039V641H1018.95V621ZM1041 621H1061.05V641H1041V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 598H1103.16V642H1061.05V598ZM1062.06 599H1102.16V619H1062.06V599ZM1061.05 621H1081.1V641H1061.05V621ZM1083.11 621H1103.16V641H1083.11V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 598H134.737V642H92.6316V598ZM93.6341 599H133.734V619H93.6341V599ZM92.6316 621H112.682V641H92.6316V621ZM114.687 621H134.737V641H114.687V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 598H176.842V642H134.737V598ZM135.739 599H175.84V619H135.739V599ZM134.737 621H154.787V641H134.737V621ZM156.792 621H176.842V641H156.792V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 598H471.579V642H429.474V598ZM430.476 599H470.576V619H430.476V599ZM429.474 621H449.524V641H429.474V621ZM451.529 621H471.579V641H451.529V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 598H513.684V642H471.579V598ZM472.581 599H512.682V619H472.581V599ZM471.579 621H491.629V641H471.579V621ZM493.634 621H513.684V641H493.634V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 598H892.632V642H850.526V598ZM851.529 599H891.629V619H851.529V599ZM850.526 621H870.576V641H850.526V621ZM872.581 621H892.632V641H872.581V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 598H934.737V642H892.632V598ZM893.634 599H933.734V619H893.634V599ZM892.632 621H912.682V641H892.632V621ZM914.687 621H934.737V641H914.687V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 598H808.421V642H766.316V598ZM767.318 599H807.419V619H767.318V599ZM766.316 621H786.366V641H766.316V621ZM788.371 621H808.421V641H788.371V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 598H850.526V642H808.421V598ZM809.424 599H849.524V619H809.424V599ZM808.421 621H828.471V641H808.421V621ZM830.476 621H850.526V641H830.476V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 598H1229.47V642H1187.37V598ZM1188.37 599H1228.47V619H1188.37V599ZM1187.37 621H1207.42V641H1187.37V621ZM1209.42 621H1229.47V641H1209.42V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 598H1271.58V642H1229.47V598ZM1230.48 599H1270.58V619H1230.48V599ZM1229.47 621H1249.52V641H1229.47V621ZM1251.53 621H1271.58V641H1251.53V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 598H1397.89V642H1355.79V598ZM1356.79 599H1396.89V619H1356.79V599ZM1355.79 621H1375.84V641H1355.79V621ZM1377.84 621H1397.89V641H1377.84V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 598H1440V642H1397.89V598ZM1398.9 599H1439V619H1398.9V599ZM1397.89 621H1417.94V641H1397.89V621ZM1419.95 621H1440V641H1419.95V621Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 642H-117.895V686H-160V642ZM-158.997 643H-118.897V663H-158.997V643ZM-160 665H-139.95V685H-160V665ZM-137.945 665H-117.895V685H-137.945V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 642H-75.7895V686H-117.895V642ZM-116.892 643H-76.792V663H-116.892V643ZM-117.895 665H-97.8446V685H-117.895V665ZM-95.8396 665H-75.7895V685H-95.8396V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 642H218.947V686H176.842V642ZM177.845 643H217.945V663H177.845V643ZM176.842 665H196.892V685H176.842V665ZM198.897 665H218.947V685H198.897V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 642H261.053V686H218.947V642ZM219.95 643H260.05V663H219.95V643ZM218.947 665H238.997V685H218.947V665ZM241.003 665H261.053V685H241.003V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 642H555.789V686H513.684V642ZM514.687 643H554.787V663H514.687V643ZM513.684 665H533.734V685H513.684V665ZM535.739 665H555.789V685H535.739V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 642H597.895V686H555.789V642ZM556.792 643H596.892V663H556.792V643ZM555.789 665H575.84V685H555.789V665ZM577.845 665H597.895V685H577.845V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 642H976.842V686H934.737V642ZM935.739 643H975.84V663H935.739V643ZM934.737 665H954.787V685H934.737V665ZM956.792 665H976.842V685H956.792V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 642H1018.95V686H976.842V642ZM977.845 643H1017.94V663H977.845V643ZM976.842 665H996.892V685H976.842V665ZM998.897 665H1018.95V685H998.897V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 642H50.5263V686H8.42105V642ZM9.42355 643H49.5238V663H9.42355V643ZM8.42105 665H28.4712V685H8.42105V665ZM30.4762 665H50.5263V685H30.4762V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 642H92.6316V686H50.5263V642ZM51.5288 643H91.6291V663H51.5288V643ZM50.5263 665H70.5764V685H50.5263V665ZM72.5815 665H92.6316V685H72.5815V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 642H387.368V686H345.263V642ZM346.266 643H386.366V663H346.266V643ZM345.263 665H365.313V685H345.263V665ZM367.318 665H387.368V685H367.318V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 642H429.474V686H387.368V642ZM388.371 643H428.471V663H388.371V643ZM387.368 665H407.419V685H387.368V665ZM409.424 665H429.474V685H409.424V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 642H724.211V686H682.105V642ZM683.108 643H723.208V663H683.108V643ZM682.105 665H702.155V685H682.105V665ZM704.16 665H724.211V685H704.16V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 642H766.316V686H724.211V642ZM725.213 643H765.313V663H725.213V643ZM724.211 665H744.261V685H724.211V665ZM746.266 665H766.316V685H746.266V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 642H1145.26V686H1103.16V642ZM1104.16 643H1144.26V663H1104.16V643ZM1103.16 665H1123.21V685H1103.16V665ZM1125.21 665H1145.26V685H1125.21V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 642H1187.37V686H1145.26V642ZM1146.27 643H1186.37V663H1146.27V643ZM1145.26 665H1165.31V685H1145.26V665ZM1167.32 665H1187.37V685H1167.32V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 642H1313.68V686H1271.58V642ZM1272.58 643H1312.68V663H1272.58V643ZM1271.58 665H1291.63V685H1271.58V665ZM1293.63 665H1313.68V685H1293.63V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 642H1355.79V686H1313.68V642ZM1314.69 643H1354.79V663H1314.69V643ZM1313.68 665H1333.73V685H1313.68V665ZM1335.74 665H1355.79V685H1335.74V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 642H-33.6842V686H-75.7895V642ZM-74.787 643H-34.6867V663H-74.787V643ZM-75.7895 665H-55.7393V685H-75.7895V665ZM-53.7343 665H-33.6842V685H-53.7343V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 642H8.42105V686H-33.6842V642ZM-32.6817 643H7.41855V663H-32.6817V643ZM-33.6842 665H-13.6341V685H-33.6842V665ZM-11.6291 665H8.42105V685H-11.6291V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 642H303.158V686H261.053V642ZM262.055 643H302.155V663H262.055V643ZM261.053 665H281.103V685H261.053V665ZM283.108 665H303.158V685H283.108V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 642H345.263V686H303.158V642ZM304.16 643H344.261V663H304.16V643ZM303.158 665H323.208V685H303.158V665ZM325.213 665H345.263V685H325.213V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 642H640V686H597.895V642ZM598.897 643H638.997V663H598.897V643ZM597.895 665H617.945V685H597.895V665ZM619.95 665H640V685H619.95V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 642H682.105V686H640V642ZM641.003 643H681.103V663H641.003V643ZM640 665H660.05V685H640V665ZM662.055 665H682.105V685H662.055V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 642H1061.05V686H1018.95V642ZM1019.95 643H1060.05V663H1019.95V643ZM1018.95 665H1039V685H1018.95V665ZM1041 665H1061.05V685H1041V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 642H1103.16V686H1061.05V642ZM1062.06 643H1102.16V663H1062.06V643ZM1061.05 665H1081.1V685H1061.05V665ZM1083.11 665H1103.16V685H1083.11V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 642H134.737V686H92.6316V642ZM93.6341 643H133.734V663H93.6341V643ZM92.6316 665H112.682V685H92.6316V665ZM114.687 665H134.737V685H114.687V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 642H176.842V686H134.737V642ZM135.739 643H175.84V663H135.739V643ZM134.737 665H154.787V685H134.737V665ZM156.792 665H176.842V685H156.792V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 642H471.579V686H429.474V642ZM430.476 643H470.576V663H430.476V643ZM429.474 665H449.524V685H429.474V665ZM451.529 665H471.579V685H451.529V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 642H513.684V686H471.579V642ZM472.581 643H512.682V663H472.581V643ZM471.579 665H491.629V685H471.579V665ZM493.634 665H513.684V685H493.634V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 642H892.632V686H850.526V642ZM851.529 643H891.629V663H851.529V643ZM850.526 665H870.576V685H850.526V665ZM872.581 665H892.632V685H872.581V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 642H934.737V686H892.632V642ZM893.634 643H933.734V663H893.634V643ZM892.632 665H912.682V685H892.632V665ZM914.687 665H934.737V685H914.687V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 642H808.421V686H766.316V642ZM767.318 643H807.419V663H767.318V643ZM766.316 665H786.366V685H766.316V665ZM788.371 665H808.421V685H788.371V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 642H850.526V686H808.421V642ZM809.424 643H849.524V663H809.424V643ZM808.421 665H828.471V685H808.421V665ZM830.476 665H850.526V685H830.476V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 642H1229.47V686H1187.37V642ZM1188.37 643H1228.47V663H1188.37V643ZM1187.37 665H1207.42V685H1187.37V665ZM1209.42 665H1229.47V685H1209.42V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 642H1271.58V686H1229.47V642ZM1230.48 643H1270.58V663H1230.48V643ZM1229.47 665H1249.52V685H1229.47V665ZM1251.53 665H1271.58V685H1251.53V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 642H1397.89V686H1355.79V642ZM1356.79 643H1396.89V663H1356.79V643ZM1355.79 665H1375.84V685H1355.79V665ZM1377.84 665H1397.89V685H1377.84V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 642H1440V686H1397.89V642ZM1398.9 643H1439V663H1398.9V643ZM1397.89 665H1417.94V685H1397.89V665ZM1419.95 665H1440V685H1419.95V665Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 686H-117.895V730H-160V686ZM-158.997 687H-118.897V707H-158.997V687ZM-160 709H-139.95V729H-160V709ZM-137.945 709H-117.895V729H-137.945V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 686H-75.7895V730H-117.895V686ZM-116.892 687H-76.792V707H-116.892V687ZM-117.895 709H-97.8446V729H-117.895V709ZM-95.8396 709H-75.7895V729H-95.8396V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 686H218.947V730H176.842V686ZM177.845 687H217.945V707H177.845V687ZM176.842 709H196.892V729H176.842V709ZM198.897 709H218.947V729H198.897V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 686H261.053V730H218.947V686ZM219.95 687H260.05V707H219.95V687ZM218.947 709H238.997V729H218.947V709ZM241.003 709H261.053V729H241.003V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 686H555.789V730H513.684V686ZM514.687 687H554.787V707H514.687V687ZM513.684 709H533.734V729H513.684V709ZM535.739 709H555.789V729H535.739V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 686H597.895V730H555.789V686ZM556.792 687H596.892V707H556.792V687ZM555.789 709H575.84V729H555.789V709ZM577.845 709H597.895V729H577.845V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 686H976.842V730H934.737V686ZM935.739 687H975.84V707H935.739V687ZM934.737 709H954.787V729H934.737V709ZM956.792 709H976.842V729H956.792V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 686H1018.95V730H976.842V686ZM977.845 687H1017.94V707H977.845V687ZM976.842 709H996.892V729H976.842V709ZM998.897 709H1018.95V729H998.897V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 686H50.5263V730H8.42105V686ZM9.42355 687H49.5238V707H9.42355V687ZM8.42105 709H28.4712V729H8.42105V709ZM30.4762 709H50.5263V729H30.4762V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 686H92.6316V730H50.5263V686ZM51.5288 687H91.6291V707H51.5288V687ZM50.5263 709H70.5764V729H50.5263V709ZM72.5815 709H92.6316V729H72.5815V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 686H387.368V730H345.263V686ZM346.266 687H386.366V707H346.266V687ZM345.263 709H365.313V729H345.263V709ZM367.318 709H387.368V729H367.318V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 686H429.474V730H387.368V686ZM388.371 687H428.471V707H388.371V687ZM387.368 709H407.419V729H387.368V709ZM409.424 709H429.474V729H409.424V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 686H724.211V730H682.105V686ZM683.108 687H723.208V707H683.108V687ZM682.105 709H702.155V729H682.105V709ZM704.16 709H724.211V729H704.16V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 686H766.316V730H724.211V686ZM725.213 687H765.313V707H725.213V687ZM724.211 709H744.261V729H724.211V709ZM746.266 709H766.316V729H746.266V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 686H1145.26V730H1103.16V686ZM1104.16 687H1144.26V707H1104.16V687ZM1103.16 709H1123.21V729H1103.16V709ZM1125.21 709H1145.26V729H1125.21V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 686H1187.37V730H1145.26V686ZM1146.27 687H1186.37V707H1146.27V687ZM1145.26 709H1165.31V729H1145.26V709ZM1167.32 709H1187.37V729H1167.32V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 686H1313.68V730H1271.58V686ZM1272.58 687H1312.68V707H1272.58V687ZM1271.58 709H1291.63V729H1271.58V709ZM1293.63 709H1313.68V729H1293.63V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 686H1355.79V730H1313.68V686ZM1314.69 687H1354.79V707H1314.69V687ZM1313.68 709H1333.73V729H1313.68V709ZM1335.74 709H1355.79V729H1335.74V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 686H-33.6842V730H-75.7895V686ZM-74.787 687H-34.6867V707H-74.787V687ZM-75.7895 709H-55.7393V729H-75.7895V709ZM-53.7343 709H-33.6842V729H-53.7343V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 686H8.42105V730H-33.6842V686ZM-32.6817 687H7.41855V707H-32.6817V687ZM-33.6842 709H-13.6341V729H-33.6842V709ZM-11.6291 709H8.42105V729H-11.6291V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 686H303.158V730H261.053V686ZM262.055 687H302.155V707H262.055V687ZM261.053 709H281.103V729H261.053V709ZM283.108 709H303.158V729H283.108V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 686H345.263V730H303.158V686ZM304.16 687H344.261V707H304.16V687ZM303.158 709H323.208V729H303.158V709ZM325.213 709H345.263V729H325.213V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 686H640V730H597.895V686ZM598.897 687H638.997V707H598.897V687ZM597.895 709H617.945V729H597.895V709ZM619.95 709H640V729H619.95V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 686H682.105V730H640V686ZM641.003 687H681.103V707H641.003V687ZM640 709H660.05V729H640V709ZM662.055 709H682.105V729H662.055V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 686H1061.05V730H1018.95V686ZM1019.95 687H1060.05V707H1019.95V687ZM1018.95 709H1039V729H1018.95V709ZM1041 709H1061.05V729H1041V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 686H1103.16V730H1061.05V686ZM1062.06 687H1102.16V707H1062.06V687ZM1061.05 709H1081.1V729H1061.05V709ZM1083.11 709H1103.16V729H1083.11V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 686H134.737V730H92.6316V686ZM93.6341 687H133.734V707H93.6341V687ZM92.6316 709H112.682V729H92.6316V709ZM114.687 709H134.737V729H114.687V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 686H176.842V730H134.737V686ZM135.739 687H175.84V707H135.739V687ZM134.737 709H154.787V729H134.737V709ZM156.792 709H176.842V729H156.792V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 686H471.579V730H429.474V686ZM430.476 687H470.576V707H430.476V687ZM429.474 709H449.524V729H429.474V709ZM451.529 709H471.579V729H451.529V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 686H513.684V730H471.579V686ZM472.581 687H512.682V707H472.581V687ZM471.579 709H491.629V729H471.579V709ZM493.634 709H513.684V729H493.634V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 686H892.632V730H850.526V686ZM851.529 687H891.629V707H851.529V687ZM850.526 709H870.576V729H850.526V709ZM872.581 709H892.632V729H872.581V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 686H934.737V730H892.632V686ZM893.634 687H933.734V707H893.634V687ZM892.632 709H912.682V729H892.632V709ZM914.687 709H934.737V729H914.687V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 686H808.421V730H766.316V686ZM767.318 687H807.419V707H767.318V687ZM766.316 709H786.366V729H766.316V709ZM788.371 709H808.421V729H788.371V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 686H850.526V730H808.421V686ZM809.424 687H849.524V707H809.424V687ZM808.421 709H828.471V729H808.421V709ZM830.476 709H850.526V729H830.476V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 686H1229.47V730H1187.37V686ZM1188.37 687H1228.47V707H1188.37V687ZM1187.37 709H1207.42V729H1187.37V709ZM1209.42 709H1229.47V729H1209.42V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 686H1271.58V730H1229.47V686ZM1230.48 687H1270.58V707H1230.48V687ZM1229.47 709H1249.52V729H1229.47V709ZM1251.53 709H1271.58V729H1251.53V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 686H1397.89V730H1355.79V686ZM1356.79 687H1396.89V707H1356.79V687ZM1355.79 709H1375.84V729H1355.79V709ZM1377.84 709H1397.89V729H1377.84V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 686H1440V730H1397.89V686ZM1398.9 687H1439V707H1398.9V687ZM1397.89 709H1417.94V729H1397.89V709ZM1419.95 709H1440V729H1419.95V709Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 730H-117.895V774H-160V730ZM-158.997 731H-118.897V751H-158.997V731ZM-160 753H-139.95V773H-160V753ZM-137.945 753H-117.895V773H-137.945V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 730H-75.7895V774H-117.895V730ZM-116.892 731H-76.792V751H-116.892V731ZM-117.895 753H-97.8446V773H-117.895V753ZM-95.8396 753H-75.7895V773H-95.8396V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 730H218.947V774H176.842V730ZM177.845 731H217.945V751H177.845V731ZM176.842 753H196.892V773H176.842V753ZM198.897 753H218.947V773H198.897V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 730H261.053V774H218.947V730ZM219.95 731H260.05V751H219.95V731ZM218.947 753H238.997V773H218.947V753ZM241.003 753H261.053V773H241.003V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 730H555.789V774H513.684V730ZM514.687 731H554.787V751H514.687V731ZM513.684 753H533.734V773H513.684V753ZM535.739 753H555.789V773H535.739V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 730H597.895V774H555.789V730ZM556.792 731H596.892V751H556.792V731ZM555.789 753H575.84V773H555.789V753ZM577.845 753H597.895V773H577.845V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 730H976.842V774H934.737V730ZM935.739 731H975.84V751H935.739V731ZM934.737 753H954.787V773H934.737V753ZM956.792 753H976.842V773H956.792V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 730H1018.95V774H976.842V730ZM977.845 731H1017.94V751H977.845V731ZM976.842 753H996.892V773H976.842V753ZM998.897 753H1018.95V773H998.897V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 730H50.5263V774H8.42105V730ZM9.42355 731H49.5238V751H9.42355V731ZM8.42105 753H28.4712V773H8.42105V753ZM30.4762 753H50.5263V773H30.4762V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 730H92.6316V774H50.5263V730ZM51.5288 731H91.6291V751H51.5288V731ZM50.5263 753H70.5764V773H50.5263V753ZM72.5815 753H92.6316V773H72.5815V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 730H387.368V774H345.263V730ZM346.266 731H386.366V751H346.266V731ZM345.263 753H365.313V773H345.263V753ZM367.318 753H387.368V773H367.318V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 730H429.474V774H387.368V730ZM388.371 731H428.471V751H388.371V731ZM387.368 753H407.419V773H387.368V753ZM409.424 753H429.474V773H409.424V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 730H724.211V774H682.105V730ZM683.108 731H723.208V751H683.108V731ZM682.105 753H702.155V773H682.105V753ZM704.16 753H724.211V773H704.16V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 730H766.316V774H724.211V730ZM725.213 731H765.313V751H725.213V731ZM724.211 753H744.261V773H724.211V753ZM746.266 753H766.316V773H746.266V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 730H1145.26V774H1103.16V730ZM1104.16 731H1144.26V751H1104.16V731ZM1103.16 753H1123.21V773H1103.16V753ZM1125.21 753H1145.26V773H1125.21V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 730H1187.37V774H1145.26V730ZM1146.27 731H1186.37V751H1146.27V731ZM1145.26 753H1165.31V773H1145.26V753ZM1167.32 753H1187.37V773H1167.32V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 730H1313.68V774H1271.58V730ZM1272.58 731H1312.68V751H1272.58V731ZM1271.58 753H1291.63V773H1271.58V753ZM1293.63 753H1313.68V773H1293.63V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 730H1355.79V774H1313.68V730ZM1314.69 731H1354.79V751H1314.69V731ZM1313.68 753H1333.73V773H1313.68V753ZM1335.74 753H1355.79V773H1335.74V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 730H-33.6842V774H-75.7895V730ZM-74.787 731H-34.6867V751H-74.787V731ZM-75.7895 753H-55.7393V773H-75.7895V753ZM-53.7343 753H-33.6842V773H-53.7343V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 730H8.42105V774H-33.6842V730ZM-32.6817 731H7.41855V751H-32.6817V731ZM-33.6842 753H-13.6341V773H-33.6842V753ZM-11.6291 753H8.42105V773H-11.6291V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 730H303.158V774H261.053V730ZM262.055 731H302.155V751H262.055V731ZM261.053 753H281.103V773H261.053V753ZM283.108 753H303.158V773H283.108V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 730H345.263V774H303.158V730ZM304.16 731H344.261V751H304.16V731ZM303.158 753H323.208V773H303.158V753ZM325.213 753H345.263V773H325.213V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 730H640V774H597.895V730ZM598.897 731H638.997V751H598.897V731ZM597.895 753H617.945V773H597.895V753ZM619.95 753H640V773H619.95V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 730H682.105V774H640V730ZM641.003 731H681.103V751H641.003V731ZM640 753H660.05V773H640V753ZM662.055 753H682.105V773H662.055V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 730H1061.05V774H1018.95V730ZM1019.95 731H1060.05V751H1019.95V731ZM1018.95 753H1039V773H1018.95V753ZM1041 753H1061.05V773H1041V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 730H1103.16V774H1061.05V730ZM1062.06 731H1102.16V751H1062.06V731ZM1061.05 753H1081.1V773H1061.05V753ZM1083.11 753H1103.16V773H1083.11V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 730H134.737V774H92.6316V730ZM93.6341 731H133.734V751H93.6341V731ZM92.6316 753H112.682V773H92.6316V753ZM114.687 753H134.737V773H114.687V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 730H176.842V774H134.737V730ZM135.739 731H175.84V751H135.739V731ZM134.737 753H154.787V773H134.737V753ZM156.792 753H176.842V773H156.792V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 730H471.579V774H429.474V730ZM430.476 731H470.576V751H430.476V731ZM429.474 753H449.524V773H429.474V753ZM451.529 753H471.579V773H451.529V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 730H513.684V774H471.579V730ZM472.581 731H512.682V751H472.581V731ZM471.579 753H491.629V773H471.579V753ZM493.634 753H513.684V773H493.634V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 730H892.632V774H850.526V730ZM851.529 731H891.629V751H851.529V731ZM850.526 753H870.576V773H850.526V753ZM872.581 753H892.632V773H872.581V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 730H934.737V774H892.632V730ZM893.634 731H933.734V751H893.634V731ZM892.632 753H912.682V773H892.632V753ZM914.687 753H934.737V773H914.687V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 730H808.421V774H766.316V730ZM767.318 731H807.419V751H767.318V731ZM766.316 753H786.366V773H766.316V753ZM788.371 753H808.421V773H788.371V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 730H850.526V774H808.421V730ZM809.424 731H849.524V751H809.424V731ZM808.421 753H828.471V773H808.421V753ZM830.476 753H850.526V773H830.476V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 730H1229.47V774H1187.37V730ZM1188.37 731H1228.47V751H1188.37V731ZM1187.37 753H1207.42V773H1187.37V753ZM1209.42 753H1229.47V773H1209.42V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 730H1271.58V774H1229.47V730ZM1230.48 731H1270.58V751H1230.48V731ZM1229.47 753H1249.52V773H1229.47V753ZM1251.53 753H1271.58V773H1251.53V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 730H1397.89V774H1355.79V730ZM1356.79 731H1396.89V751H1356.79V731ZM1355.79 753H1375.84V773H1355.79V753ZM1377.84 753H1397.89V773H1377.84V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 730H1440V774H1397.89V730ZM1398.9 731H1439V751H1398.9V731ZM1397.89 753H1417.94V773H1397.89V753ZM1419.95 753H1440V773H1419.95V753Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 774H-117.895V818H-160V774ZM-158.997 775H-118.897V795H-158.997V775ZM-160 797H-139.95V817H-160V797ZM-137.945 797H-117.895V817H-137.945V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 774H-75.7895V818H-117.895V774ZM-116.892 775H-76.792V795H-116.892V775ZM-117.895 797H-97.8446V817H-117.895V797ZM-95.8396 797H-75.7895V817H-95.8396V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 774H218.947V818H176.842V774ZM177.845 775H217.945V795H177.845V775ZM176.842 797H196.892V817H176.842V797ZM198.897 797H218.947V817H198.897V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 774H261.053V818H218.947V774ZM219.95 775H260.05V795H219.95V775ZM218.947 797H238.997V817H218.947V797ZM241.003 797H261.053V817H241.003V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 774H555.789V818H513.684V774ZM514.687 775H554.787V795H514.687V775ZM513.684 797H533.734V817H513.684V797ZM535.739 797H555.789V817H535.739V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 774H597.895V818H555.789V774ZM556.792 775H596.892V795H556.792V775ZM555.789 797H575.84V817H555.789V797ZM577.845 797H597.895V817H577.845V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 774H976.842V818H934.737V774ZM935.739 775H975.84V795H935.739V775ZM934.737 797H954.787V817H934.737V797ZM956.792 797H976.842V817H956.792V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 774H1018.95V818H976.842V774ZM977.845 775H1017.94V795H977.845V775ZM976.842 797H996.892V817H976.842V797ZM998.897 797H1018.95V817H998.897V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 774H50.5263V818H8.42105V774ZM9.42355 775H49.5238V795H9.42355V775ZM8.42105 797H28.4712V817H8.42105V797ZM30.4762 797H50.5263V817H30.4762V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 774H92.6316V818H50.5263V774ZM51.5288 775H91.6291V795H51.5288V775ZM50.5263 797H70.5764V817H50.5263V797ZM72.5815 797H92.6316V817H72.5815V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 774H387.368V818H345.263V774ZM346.266 775H386.366V795H346.266V775ZM345.263 797H365.313V817H345.263V797ZM367.318 797H387.368V817H367.318V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 774H429.474V818H387.368V774ZM388.371 775H428.471V795H388.371V775ZM387.368 797H407.419V817H387.368V797ZM409.424 797H429.474V817H409.424V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 774H724.211V818H682.105V774ZM683.108 775H723.208V795H683.108V775ZM682.105 797H702.155V817H682.105V797ZM704.16 797H724.211V817H704.16V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 774H766.316V818H724.211V774ZM725.213 775H765.313V795H725.213V775ZM724.211 797H744.261V817H724.211V797ZM746.266 797H766.316V817H746.266V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 774H1145.26V818H1103.16V774ZM1104.16 775H1144.26V795H1104.16V775ZM1103.16 797H1123.21V817H1103.16V797ZM1125.21 797H1145.26V817H1125.21V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 774H1187.37V818H1145.26V774ZM1146.27 775H1186.37V795H1146.27V775ZM1145.26 797H1165.31V817H1145.26V797ZM1167.32 797H1187.37V817H1167.32V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 774H1313.68V818H1271.58V774ZM1272.58 775H1312.68V795H1272.58V775ZM1271.58 797H1291.63V817H1271.58V797ZM1293.63 797H1313.68V817H1293.63V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 774H1355.79V818H1313.68V774ZM1314.69 775H1354.79V795H1314.69V775ZM1313.68 797H1333.73V817H1313.68V797ZM1335.74 797H1355.79V817H1335.74V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 774H-33.6842V818H-75.7895V774ZM-74.787 775H-34.6867V795H-74.787V775ZM-75.7895 797H-55.7393V817H-75.7895V797ZM-53.7343 797H-33.6842V817H-53.7343V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 774H8.42105V818H-33.6842V774ZM-32.6817 775H7.41855V795H-32.6817V775ZM-33.6842 797H-13.6341V817H-33.6842V797ZM-11.6291 797H8.42105V817H-11.6291V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 774H303.158V818H261.053V774ZM262.055 775H302.155V795H262.055V775ZM261.053 797H281.103V817H261.053V797ZM283.108 797H303.158V817H283.108V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 774H345.263V818H303.158V774ZM304.16 775H344.261V795H304.16V775ZM303.158 797H323.208V817H303.158V797ZM325.213 797H345.263V817H325.213V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 774H640V818H597.895V774ZM598.897 775H638.997V795H598.897V775ZM597.895 797H617.945V817H597.895V797ZM619.95 797H640V817H619.95V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 774H682.105V818H640V774ZM641.003 775H681.103V795H641.003V775ZM640 797H660.05V817H640V797ZM662.055 797H682.105V817H662.055V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 774H1061.05V818H1018.95V774ZM1019.95 775H1060.05V795H1019.95V775ZM1018.95 797H1039V817H1018.95V797ZM1041 797H1061.05V817H1041V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 774H1103.16V818H1061.05V774ZM1062.06 775H1102.16V795H1062.06V775ZM1061.05 797H1081.1V817H1061.05V797ZM1083.11 797H1103.16V817H1083.11V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 774H134.737V818H92.6316V774ZM93.6341 775H133.734V795H93.6341V775ZM92.6316 797H112.682V817H92.6316V797ZM114.687 797H134.737V817H114.687V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 774H176.842V818H134.737V774ZM135.739 775H175.84V795H135.739V775ZM134.737 797H154.787V817H134.737V797ZM156.792 797H176.842V817H156.792V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 774H471.579V818H429.474V774ZM430.476 775H470.576V795H430.476V775ZM429.474 797H449.524V817H429.474V797ZM451.529 797H471.579V817H451.529V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 774H513.684V818H471.579V774ZM472.581 775H512.682V795H472.581V775ZM471.579 797H491.629V817H471.579V797ZM493.634 797H513.684V817H493.634V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 774H892.632V818H850.526V774ZM851.529 775H891.629V795H851.529V775ZM850.526 797H870.576V817H850.526V797ZM872.581 797H892.632V817H872.581V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 774H934.737V818H892.632V774ZM893.634 775H933.734V795H893.634V775ZM892.632 797H912.682V817H892.632V797ZM914.687 797H934.737V817H914.687V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 774H808.421V818H766.316V774ZM767.318 775H807.419V795H767.318V775ZM766.316 797H786.366V817H766.316V797ZM788.371 797H808.421V817H788.371V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 774H850.526V818H808.421V774ZM809.424 775H849.524V795H809.424V775ZM808.421 797H828.471V817H808.421V797ZM830.476 797H850.526V817H830.476V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 774H1229.47V818H1187.37V774ZM1188.37 775H1228.47V795H1188.37V775ZM1187.37 797H1207.42V817H1187.37V797ZM1209.42 797H1229.47V817H1209.42V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 774H1271.58V818H1229.47V774ZM1230.48 775H1270.58V795H1230.48V775ZM1229.47 797H1249.52V817H1229.47V797ZM1251.53 797H1271.58V817H1251.53V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 774H1397.89V818H1355.79V774ZM1356.79 775H1396.89V795H1356.79V775ZM1355.79 797H1375.84V817H1355.79V797ZM1377.84 797H1397.89V817H1377.84V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 774H1440V818H1397.89V774ZM1398.9 775H1439V795H1398.9V775ZM1397.89 797H1417.94V817H1397.89V797ZM1419.95 797H1440V817H1419.95V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 774H-117.895V818H-160V774ZM-158.997 775H-118.897V795H-158.997V775ZM-160 797H-139.95V817H-160V797ZM-137.945 797H-117.895V817H-137.945V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 774H-75.7895V818H-117.895V774ZM-116.892 775H-76.792V795H-116.892V775ZM-117.895 797H-97.8446V817H-117.895V797ZM-95.8396 797H-75.7895V817H-95.8396V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 774H218.947V818H176.842V774ZM177.845 775H217.945V795H177.845V775ZM176.842 797H196.892V817H176.842V797ZM198.897 797H218.947V817H198.897V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 774H261.053V818H218.947V774ZM219.95 775H260.05V795H219.95V775ZM218.947 797H238.997V817H218.947V797ZM241.003 797H261.053V817H241.003V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 774H555.789V818H513.684V774ZM514.687 775H554.787V795H514.687V775ZM513.684 797H533.734V817H513.684V797ZM535.739 797H555.789V817H535.739V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 774H597.895V818H555.789V774ZM556.792 775H596.892V795H556.792V775ZM555.789 797H575.84V817H555.789V797ZM577.845 797H597.895V817H577.845V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 774H976.842V818H934.737V774ZM935.739 775H975.84V795H935.739V775ZM934.737 797H954.787V817H934.737V797ZM956.792 797H976.842V817H956.792V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 774H1018.95V818H976.842V774ZM977.845 775H1017.94V795H977.845V775ZM976.842 797H996.892V817H976.842V797ZM998.897 797H1018.95V817H998.897V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 774H50.5263V818H8.42105V774ZM9.42355 775H49.5238V795H9.42355V775ZM8.42105 797H28.4712V817H8.42105V797ZM30.4762 797H50.5263V817H30.4762V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 774H92.6316V818H50.5263V774ZM51.5288 775H91.6291V795H51.5288V775ZM50.5263 797H70.5764V817H50.5263V797ZM72.5815 797H92.6316V817H72.5815V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 774H387.368V818H345.263V774ZM346.266 775H386.366V795H346.266V775ZM345.263 797H365.313V817H345.263V797ZM367.318 797H387.368V817H367.318V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 774H429.474V818H387.368V774ZM388.371 775H428.471V795H388.371V775ZM387.368 797H407.419V817H387.368V797ZM409.424 797H429.474V817H409.424V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 774H724.211V818H682.105V774ZM683.108 775H723.208V795H683.108V775ZM682.105 797H702.155V817H682.105V797ZM704.16 797H724.211V817H704.16V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 774H766.316V818H724.211V774ZM725.213 775H765.313V795H725.213V775ZM724.211 797H744.261V817H724.211V797ZM746.266 797H766.316V817H746.266V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 774H1145.26V818H1103.16V774ZM1104.16 775H1144.26V795H1104.16V775ZM1103.16 797H1123.21V817H1103.16V797ZM1125.21 797H1145.26V817H1125.21V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 774H1187.37V818H1145.26V774ZM1146.27 775H1186.37V795H1146.27V775ZM1145.26 797H1165.31V817H1145.26V797ZM1167.32 797H1187.37V817H1167.32V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 774H1313.68V818H1271.58V774ZM1272.58 775H1312.68V795H1272.58V775ZM1271.58 797H1291.63V817H1271.58V797ZM1293.63 797H1313.68V817H1293.63V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 774H1355.79V818H1313.68V774ZM1314.69 775H1354.79V795H1314.69V775ZM1313.68 797H1333.73V817H1313.68V797ZM1335.74 797H1355.79V817H1335.74V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 774H-33.6842V818H-75.7895V774ZM-74.787 775H-34.6867V795H-74.787V775ZM-75.7895 797H-55.7393V817H-75.7895V797ZM-53.7343 797H-33.6842V817H-53.7343V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 774H8.42105V818H-33.6842V774ZM-32.6817 775H7.41855V795H-32.6817V775ZM-33.6842 797H-13.6341V817H-33.6842V797ZM-11.6291 797H8.42105V817H-11.6291V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 774H303.158V818H261.053V774ZM262.055 775H302.155V795H262.055V775ZM261.053 797H281.103V817H261.053V797ZM283.108 797H303.158V817H283.108V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 774H345.263V818H303.158V774ZM304.16 775H344.261V795H304.16V775ZM303.158 797H323.208V817H303.158V797ZM325.213 797H345.263V817H325.213V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 774H640V818H597.895V774ZM598.897 775H638.997V795H598.897V775ZM597.895 797H617.945V817H597.895V797ZM619.95 797H640V817H619.95V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 774H682.105V818H640V774ZM641.003 775H681.103V795H641.003V775ZM640 797H660.05V817H640V797ZM662.055 797H682.105V817H662.055V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 774H1061.05V818H1018.95V774ZM1019.95 775H1060.05V795H1019.95V775ZM1018.95 797H1039V817H1018.95V797ZM1041 797H1061.05V817H1041V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 774H1103.16V818H1061.05V774ZM1062.06 775H1102.16V795H1062.06V775ZM1061.05 797H1081.1V817H1061.05V797ZM1083.11 797H1103.16V817H1083.11V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 774H134.737V818H92.6316V774ZM93.6341 775H133.734V795H93.6341V775ZM92.6316 797H112.682V817H92.6316V797ZM114.687 797H134.737V817H114.687V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 774H176.842V818H134.737V774ZM135.739 775H175.84V795H135.739V775ZM134.737 797H154.787V817H134.737V797ZM156.792 797H176.842V817H156.792V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 774H471.579V818H429.474V774ZM430.476 775H470.576V795H430.476V775ZM429.474 797H449.524V817H429.474V797ZM451.529 797H471.579V817H451.529V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 774H513.684V818H471.579V774ZM472.581 775H512.682V795H472.581V775ZM471.579 797H491.629V817H471.579V797ZM493.634 797H513.684V817H493.634V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 774H892.632V818H850.526V774ZM851.529 775H891.629V795H851.529V775ZM850.526 797H870.576V817H850.526V797ZM872.581 797H892.632V817H872.581V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 774H934.737V818H892.632V774ZM893.634 775H933.734V795H893.634V775ZM892.632 797H912.682V817H892.632V797ZM914.687 797H934.737V817H914.687V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 774H808.421V818H766.316V774ZM767.318 775H807.419V795H767.318V775ZM766.316 797H786.366V817H766.316V797ZM788.371 797H808.421V817H788.371V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 774H850.526V818H808.421V774ZM809.424 775H849.524V795H809.424V775ZM808.421 797H828.471V817H808.421V797ZM830.476 797H850.526V817H830.476V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 774H1229.47V818H1187.37V774ZM1188.37 775H1228.47V795H1188.37V775ZM1187.37 797H1207.42V817H1187.37V797ZM1209.42 797H1229.47V817H1209.42V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 774H1271.58V818H1229.47V774ZM1230.48 775H1270.58V795H1230.48V775ZM1229.47 797H1249.52V817H1229.47V797ZM1251.53 797H1271.58V817H1251.53V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 774H1397.89V818H1355.79V774ZM1356.79 775H1396.89V795H1356.79V775ZM1355.79 797H1375.84V817H1355.79V797ZM1377.84 797H1397.89V817H1377.84V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 774H1440V818H1397.89V774ZM1398.9 775H1439V795H1398.9V775ZM1397.89 797H1417.94V817H1397.89V797ZM1419.95 797H1440V817H1419.95V797Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160 818H-117.895V862H-160V818ZM-158.997 819H-118.897V839H-158.997V819ZM-160 841H-139.95V861H-160V841ZM-137.945 841H-117.895V861H-137.945V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.895 818H-75.7895V862H-117.895V818ZM-116.892 819H-76.792V839H-116.892V819ZM-117.895 841H-97.8446V861H-117.895V841ZM-95.8396 841H-75.7895V861H-95.8396V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.842 818H218.947V862H176.842V818ZM177.845 819H217.945V839H177.845V819ZM176.842 841H196.892V861H176.842V841ZM198.897 841H218.947V861H198.897V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.947 818H261.053V862H218.947V818ZM219.95 819H260.05V839H219.95V819ZM218.947 841H238.997V861H218.947V841ZM241.003 841H261.053V861H241.003V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.684 818H555.789V862H513.684V818ZM514.687 819H554.787V839H514.687V819ZM513.684 841H533.734V861H513.684V841ZM535.739 841H555.789V861H535.739V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.789 818H597.895V862H555.789V818ZM556.792 819H596.892V839H556.792V819ZM555.789 841H575.84V861H555.789V841ZM577.845 841H597.895V861H577.845V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.737 818H976.842V862H934.737V818ZM935.739 819H975.84V839H935.739V819ZM934.737 841H954.787V861H934.737V841ZM956.792 841H976.842V861H956.792V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.842 818H1018.95V862H976.842V818ZM977.845 819H1017.94V839H977.845V819ZM976.842 841H996.892V861H976.842V841ZM998.897 841H1018.95V861H998.897V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42105 818H50.5263V862H8.42105V818ZM9.42355 819H49.5238V839H9.42355V819ZM8.42105 841H28.4712V861H8.42105V841ZM30.4762 841H50.5263V861H30.4762V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5263 818H92.6316V862H50.5263V818ZM51.5288 819H91.6291V839H51.5288V819ZM50.5263 841H70.5764V861H50.5263V841ZM72.5815 841H92.6316V861H72.5815V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.263 818H387.368V862H345.263V818ZM346.266 819H386.366V839H346.266V819ZM345.263 841H365.313V861H345.263V841ZM367.318 841H387.368V861H367.318V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.368 818H429.474V862H387.368V818ZM388.371 819H428.471V839H388.371V819ZM387.368 841H407.419V861H387.368V841ZM409.424 841H429.474V861H409.424V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.105 818H724.211V862H682.105V818ZM683.108 819H723.208V839H683.108V819ZM682.105 841H702.155V861H682.105V841ZM704.16 841H724.211V861H704.16V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.211 818H766.316V862H724.211V818ZM725.213 819H765.313V839H725.213V819ZM724.211 841H744.261V861H724.211V841ZM746.266 841H766.316V861H746.266V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.16 818H1145.26V862H1103.16V818ZM1104.16 819H1144.26V839H1104.16V819ZM1103.16 841H1123.21V861H1103.16V841ZM1125.21 841H1145.26V861H1125.21V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.26 818H1187.37V862H1145.26V818ZM1146.27 819H1186.37V839H1146.27V819ZM1145.26 841H1165.31V861H1145.26V841ZM1167.32 841H1187.37V861H1167.32V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.58 818H1313.68V862H1271.58V818ZM1272.58 819H1312.68V839H1272.58V819ZM1271.58 841H1291.63V861H1271.58V841ZM1293.63 841H1313.68V861H1293.63V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.68 818H1355.79V862H1313.68V818ZM1314.69 819H1354.79V839H1314.69V819ZM1313.68 841H1333.73V861H1313.68V841ZM1335.74 841H1355.79V861H1335.74V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-75.7895 818H-33.6842V862H-75.7895V818ZM-74.787 819H-34.6867V839H-74.787V819ZM-75.7895 841H-55.7393V861H-75.7895V841ZM-53.7343 841H-33.6842V861H-53.7343V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-33.6842 818H8.42105V862H-33.6842V818ZM-32.6817 819H7.41855V839H-32.6817V819ZM-33.6842 841H-13.6341V861H-33.6842V841ZM-11.6291 841H8.42105V861H-11.6291V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.053 818H303.158V862H261.053V818ZM262.055 819H302.155V839H262.055V819ZM261.053 841H281.103V861H261.053V841ZM283.108 841H303.158V861H283.108V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.158 818H345.263V862H303.158V818ZM304.16 819H344.261V839H304.16V819ZM303.158 841H323.208V861H303.158V841ZM325.213 841H345.263V861H325.213V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.895 818H640V862H597.895V818ZM598.897 819H638.997V839H598.897V819ZM597.895 841H617.945V861H597.895V841ZM619.95 841H640V861H619.95V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 818H682.105V862H640V818ZM641.003 819H681.103V839H641.003V819ZM640 841H660.05V861H640V841ZM662.055 841H682.105V861H662.055V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.95 818H1061.05V862H1018.95V818ZM1019.95 819H1060.05V839H1019.95V819ZM1018.95 841H1039V861H1018.95V841ZM1041 841H1061.05V861H1041V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.05 818H1103.16V862H1061.05V818ZM1062.06 819H1102.16V839H1062.06V819ZM1061.05 841H1081.1V861H1061.05V841ZM1083.11 841H1103.16V861H1083.11V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6316 818H134.737V862H92.6316V818ZM93.6341 819H133.734V839H93.6341V819ZM92.6316 841H112.682V861H92.6316V841ZM114.687 841H134.737V861H114.687V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.737 818H176.842V862H134.737V818ZM135.739 819H175.84V839H135.739V819ZM134.737 841H154.787V861H134.737V841ZM156.792 841H176.842V861H156.792V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.474 818H471.579V862H429.474V818ZM430.476 819H470.576V839H430.476V819ZM429.474 841H449.524V861H429.474V841ZM451.529 841H471.579V861H451.529V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.579 818H513.684V862H471.579V818ZM472.581 819H512.682V839H472.581V819ZM471.579 841H491.629V861H471.579V841ZM493.634 841H513.684V861H493.634V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.526 818H892.632V862H850.526V818ZM851.529 819H891.629V839H851.529V819ZM850.526 841H870.576V861H850.526V841ZM872.581 841H892.632V861H872.581V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.632 818H934.737V862H892.632V818ZM893.634 819H933.734V839H893.634V819ZM892.632 841H912.682V861H892.632V841ZM914.687 841H934.737V861H914.687V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.316 818H808.421V862H766.316V818ZM767.318 819H807.419V839H767.318V819ZM766.316 841H786.366V861H766.316V841ZM788.371 841H808.421V861H788.371V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.421 818H850.526V862H808.421V818ZM809.424 819H849.524V839H809.424V819ZM808.421 841H828.471V861H808.421V841ZM830.476 841H850.526V861H830.476V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.37 818H1229.47V862H1187.37V818ZM1188.37 819H1228.47V839H1188.37V819ZM1187.37 841H1207.42V861H1187.37V841ZM1209.42 841H1229.47V861H1209.42V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1229.47 818H1271.58V862H1229.47V818ZM1230.48 819H1270.58V839H1230.48V819ZM1229.47 841H1249.52V861H1229.47V841ZM1251.53 841H1271.58V861H1251.53V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.79 818H1397.89V862H1355.79V818ZM1356.79 819H1396.89V839H1356.79V819ZM1355.79 841H1375.84V861H1355.79V841ZM1377.84 841H1397.89V861H1377.84V841Z",
    fill: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.89 818H1440V862H1397.89V818ZM1398.9 819H1439V839H1398.9V819ZM1397.89 841H1417.94V861H1397.89V841ZM1419.95 841H1440V861H1419.95V841Z",
    fill: "#CBD5E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAuth);
export default __webpack_public_path__ + "static/media/bg_auth.5bca2238b179e3485e34dbdc0cbb3b9d.svg";
export { ForwardRef as ReactComponent };